/**
 * GMP Theme — Gers Moto Pièces
 * Main JavaScript
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
     UTILITAIRES
     ═══════════════════════════════════════════════════════ */

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  /* ⚠️ **LE FORMAT VIENT DE LA BOUTIQUE, IL N'EST PLUS ÉCRIT ICI.** Le filtre
     Liquid `money` rend « 250,00€ » (le `money_format` du marchand, sans espace)
     quand ce code rendait « 250,00 € » : le prix CHANGEAIT D'ASPECT au premier
     changement de variante, et le tiroir ne montrait pas la même chose que la
     fiche. Deux écritures du même fait finissent toujours par diverger — celle-ci
     avait divergé d'une espace, assez pour se voir.
     `window.GMP_MONEY` est posé par `theme.liquid` depuis `shop.money_format` ;
     le repli garde l'ancien rendu si le layout ne l'a pas émis (page mot de passe,
     fiche injectée par un vieux cache). */
  const money = (cents) => {
    const n = (cents || 0) / 100;
    const fmt = window.GMP_MONEY;
    if (!fmt) return n.toFixed(2).replace('.', ',') + ' €';
    /* Les quatre jetons de Shopify. `_no_decimals` arrondit à l'euro ; les
       variantes `with_comma_separator` mettent la virgule en séparateur décimal
       et le point (ou l'espace) aux milliers — on s'en tient à la virgule seule,
       le catalogue ne dépassant pas les milliers d'euros. */
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, jeton) => {
      switch (jeton) {
        case 'amount_no_decimals':
        case 'amount_no_decimals_with_comma_separator':
        case 'amount_no_decimals_with_space_separator':
          return String(Math.round(n));
        case 'amount_with_comma_separator':
          return n.toFixed(2).replace('.', ',');
        case 'amount_with_apostrophe_separator':
        case 'amount':
        default:
          return n.toFixed(2);
      }
    });
  };

  /* ── Film d'attente ───────────────────────────────────────────────────
     Certaines actions font travailler le serveur plusieurs secondes : créer une
     fiche produit à la volée, découper une commande entre notre stock et Ducati.
     Le seul retour était le libellé du bouton qui changeait — sur mobile il est
     en bas de l'écran, souvent hors du champ de regard, et le client recliquait.
     Le film couvre l'écran, dit ce qui se passe, et rend le second clic
     impossible par construction.
     `gmpBusy()` est rejouable : rappelée pendant que le film est levé, elle ne
     fait que changer le message — c'est ce qui permet de raconter les étapes. */
  let _busyLeve = false;

  function gmpBusy(texte) {
    const el = document.getElementById('gmp-busy');
    if (!el) return;
    const t = document.getElementById('gmp-busy-txt');
    if (t && texte) t.textContent = texte;
    if (_busyLeve) return;
    _busyLeve = true;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  /* Idempotente : le `finally` de l'appelant la rappelle après coup, et elle ne
     doit pas déverrouiller le défilement que le tiroir du panier vient de
     reprendre à son compte. */
  function gmpBusyOff() {
    if (!_busyLeve) return;
    _busyLeve = false;
    const el = document.getElementById('gmp-busy');
    if (el) el.hidden = true;
    document.body.style.overflow = '';
  }

  /* Un fetch sans délai peut ne jamais revenir : le film resterait levé sur une
     page devenue inerte, ce qui est pire que pas de film du tout. */
  const sigDelai = (ms) =>
    (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
      ? AbortSignal.timeout(ms) : undefined;

  /* ── État de navigation inline (L1 → L2 → zone → L3 → produit) ── */
  let _gmpNav = { l2: null, zone: null, l3: null, p: null };
  let _productScrollTarget = null; // position absolue de la carte avant ouverture du panel

  function _buildNavUrl(st) {
    const q = new URLSearchParams();
    if (st.l2)   q.set('l2', st.l2);
    if (st.zone) q.set('z',  st.zone);
    if (st.l3)   q.set('l3', st.l3);
    if (st.p)    q.set('p',  st.p);
    const s = q.toString();
    return window.location.pathname + (s ? '?' + s : '');
  }

  function pushGmpState(partial) {
    _gmpNav = Object.assign({}, _gmpNav, partial);
    history.pushState({ gmpNav: Object.assign({}, _gmpNav) }, '', _buildNavUrl(_gmpNav));
    _gmpTrack(partial);
  }

  function _gmpTrack(changed) {
    try {
      if (typeof gtag !== 'function') return;
      if (changed.l2)   gtag('event', 'gmp_select_model',    { event_category: 'navigation', model:    changed.l2 });
      if (changed.zone) gtag('event', 'gmp_select_zone',     { event_category: 'navigation', zone:     changed.zone,  model:    _gmpNav.l2 });
      if (changed.l3)   gtag('event', 'gmp_select_category', { event_category: 'navigation', category: changed.l3,   model:    _gmpNav.l2 });
      if (changed.p)    gtag('event', 'gmp_view_product',    { event_category: 'navigation', product:  changed.p,    category: _gmpNav.l3 });
    } catch (e) {}
  }

  /* Retourne le scope DOM actif (l1-panel si ouvert, sinon null → document) */
  function _navScope() {
    const p = document.getElementById('gmp-l1-panel');
    return (p && !p.hidden) ? p : null;
  }

  /* Applique une transition : ferme ce qui était dans "from" mais absent de "target" */
  function _applyNavState(target, from) {
    const depth = s => (s.l2?1:0) + (s.zone?1:0) + (s.l3?1:0) + (s.p?1:0);
    if (depth(target) > depth(from)) { window.location.href = _buildNavUrl(target); return; }

    const ctx = _navScope();
    const doc = ctx || document;
    const qs  = id => doc.querySelector('#' + id);

    if (from.p && !target.p) {
      const pp = qs('gmp-product-panel');
      if (pp && !pp.hidden) {
        pp.hidden = true; pp.innerHTML = '';
        const target = _productScrollTarget;
        _productScrollTarget = null;
        doc.querySelectorAll('.gmp-product-card.active').forEach(c => c.classList.remove('active'));
        requestAnimationFrame(() => {
          if (target !== null) {
            window.scrollTo({ top: Math.max(0, target), behavior: 'instant' });
          } else {
            const grid = qs('gmp-product-grid');
            if (grid) scrollToEl(grid);
          }
        });
      }
    }

    if (from.l3 && !target.l3) {
      const pp = qs('gmp-products-panel');
      if (pp && !pp.hidden) {
        pp.hidden = true; pp.innerHTML = '';
        doc.querySelectorAll('.gmp-cat-card.active').forEach(c => c.classList.remove('active'));
        const grid = doc.querySelector('.gmp-pieces-grid:not([hidden]), .gmp-entretiens-grid:not([hidden]), .gmp-accessoires-grid:not([hidden]), .gmp-collection-grid--entretiens:not([hidden])');
        if (grid) scrollToEl(grid);
      }
    }

    if (from.zone && !target.zone) {
      ['pieces', 'accessoires', 'entretiens'].forEach(z => {
        const btn  = doc.querySelector('[data-zone-toggle="' + z + '"]');
        const grid = qs('gmp-' + z + '-grid');
        if (btn)  btn.setAttribute('aria-expanded', 'false');
        if (grid) grid.hidden = true;
      });
      const zonesEl = doc.querySelector('.gmp-zones');
      if (zonesEl) scrollToEl(zonesEl);
    }

    if (from.l2 && !target.l2) {
      const panel = document.querySelector('#gmp-l1-panel');
      if (panel) {
        panel.hidden = true; panel.innerHTML = '';
        $$('.gmp-l1-card').forEach(c => c.classList.remove('active'));
        const grid = document.querySelector('.gmp-collection-grid--models');
        if (grid) scrollToEl(grid);
      }
    }
  }

  /* ═══════════════════════════════════════════════════════
     HEADER — Burger menu mobile
     ═══════════════════════════════════════════════════════ */

  const burger = $('#gmp-burger');
  const navDrawer = $('#gmp-nav-drawer');
  const overlay = $('#gmp-overlay');

  function openDrawer(drawer) {
    drawer.classList.add('open');
    overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  if (burger && navDrawer) {
    burger.addEventListener('click', () => openDrawer(navDrawer));
    const navClose = $('#gmp-nav-close');
    if (navClose) navClose.addEventListener('click', () => closeDrawer(navDrawer));
  }

  /* ═══════════════════════════════════════════════════════
     HEADER — Barre de recherche + recherche prédictive
     ═══════════════════════════════════════════════════════ */

  const searchBtn    = $('#gmp-search-btn');
  const searchBar    = $('#gmp-search-bar');
  const searchInput  = $('#gmp-search-input');
  const searchClose  = $('#gmp-search-close');
  const searchResults = $('#gmp-search-results');

  function closeSearchBar() {
    if (searchBar) searchBar.classList.remove('open');
    if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
  }

  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', () => {
      const open = searchBar.classList.toggle('open');
      if (open && searchInput) setTimeout(() => searchInput.focus(), 50);
      if (!open) { searchResults.hidden = true; searchResults.innerHTML = ''; }
    });
    if (searchClose) searchClose.addEventListener('click', closeSearchBar);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearchBar(); });
  }

  /* Recherche prédictive */
  let searchTimer = null;
  const SEARCH_MIN = 2;

  function renderPredictive(products, query) {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML = '<p class="gmp-ps-empty">Aucun résultat pour \u00ab\u00a0' + query + '\u00a0\u00bb</p>';
      searchResults.hidden = false;
      return;
    }
    let html = '<ul class="gmp-ps-list">';
    products.forEach(function(p) {
      const img = p.featured_image
        ? '<img class="gmp-ps-item__img" src="' + p.featured_image.url + '" alt="" width="52" height="52" loading="lazy">'
        : '<span class="gmp-ps-item__no-img"></span>';
      const price = p.price ? '<span class="gmp-ps-item__price">' + parseFloat(p.price).toFixed(2).replace('.', ',') + '\u00a0\u20ac</span>' : '';
      html += '<li><a href="' + p.url + '" class="gmp-ps-item">' + img
            + '<span class="gmp-ps-item__body"><span class="gmp-ps-item__title">' + p.title + '</span>' + price + '</span>'
            + '</a></li>';
    });
    html += '</ul><a href="/search?type=product&q=' + encodeURIComponent(query)
          + '" class="gmp-ps-footer">Voir tous les r\u00e9sultats pour \u00ab\u00a0' + query + '\u00a0\u00bb</a>';
    searchResults.innerHTML = html;
    searchResults.hidden = false;
  }

  function fetchPredictive(query) {
    if (!searchResults) return;
    searchResults.innerHTML = '<p class="gmp-search-results__loading">Recherche\u2026</p>';
    searchResults.hidden = false;
    const url = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product&resources[limit]=8'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,body';
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderPredictive(products, query);
      })
      .catch(function() {
        searchResults.innerHTML = '<p class="gmp-ps-empty">Erreur de recherche</p>';
        searchResults.hidden = false;
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < SEARCH_MIN) {
        if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
        return;
      }
      searchTimer = setTimeout(() => fetchPredictive(q), 280);
    });
    document.addEventListener('click', (e) => {
      if (searchBar && !searchBar.contains(e.target)) {
        if (searchResults) { searchResults.hidden = true; }
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     OVERLAY — ferme tout
     ═══════════════════════════════════════════════════════ */

  if (overlay) {
    overlay.addEventListener('click', () => {
      if (navDrawer) closeDrawer(navDrawer);
      closeCartDrawer();
    });
  }

  /* ═══════════════════════════════════════════════════════
     CART DRAWER
     ═══════════════════════════════════════════════════════ */

  const cartDrawer = $('#gmp-cart-drawer');
  const cartBtn = $('#gmp-cart-btn');
  const cartDrawerClose = $('#gmp-cart-drawer-close');

  function openCartDrawer() {
    if (!cartDrawer) return;
    refreshCartDrawer();
    cartDrawer.classList.add('open');
    overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    overlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);

  /* Rafraîchit le contenu du cart drawer via l'API /cart.js */
  /* Panier → serveur, pour l'onglet PANIERS de GMAPP (02/10/2026).
     Seulement pour un client CONNECTÉ (`window.GMP_PANIER`, signé par le
     thème) et seulement quand le contenu a changé : l'empreinte du dernier
     envoi est gardée pour la session. ⚠️ Aucun échec ne remonte au client :
     c'est un service pour le marchand, il ne doit jamais gêner un achat. */
  let _panierEmpreinte = null;
  function empreintePanier(cart) {
    return cart.token + '|' + (cart.items || []).map(i => i.variant_id + ':' + i.quantity).join(',');
  }
  function syncPanier(cart) {
    if (!cart || !cart.token) return;
    _panierEmpreinte = empreintePanier(cart);
    const p = window.GMP_PANIER;
    const api = (window.GMP_ECLATES_API || '').replace(/\/+$/, '');
    if (!p || !api) return;
    try { if (sessionStorage.getItem('gmpPanierEnvoye') === _panierEmpreinte) return; } catch (_) {}
    const envoye = _panierEmpreinte;
    fetch(api + '/panier', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-GMP-Key': window.GMP_ECLATES_KEY || '' },
      body: JSON.stringify({
        id: p.id, sig: p.sig, token: cart.token, n: cart.item_count, total: cart.total_price,
        lignes: (cart.items || []).map(i => ({ v: i.variant_id, q: i.quantity }))
      }),
      keepalive: true,
      signal: AbortSignal.timeout(10000)
    }).then(r => {
      if (r.ok) { try { sessionStorage.setItem('gmpPanierEnvoye', envoye); } catch (_) {} }
    }).catch(() => {});
  }

  /* Le marchand peut modifier ce panier depuis GMAPP pendant que le client a la
     page ouverte : au retour sur l'onglet, on relit le panier pour que le
     compteur, le tiroir — et la page panier, rechargée — disent la vérité. */
  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState !== 'visible' || !window.GMP_PANIER) return;
    try {
      const cart = await (await fetch('/cart.js')).json();
      if (_panierEmpreinte === null || empreintePanier(cart) === _panierEmpreinte) return;
      if (document.querySelector('.gmp-cart-page')) { location.reload(); return; }
      updateCartCount(cart.item_count);
      if (cartDrawer && cartDrawer.classList.contains('open')) renderCartDrawer(cart);
      syncPanier(cart);
    } catch (_) { /* silencieux : un compteur pas rafraîchi ne casse rien */ }
  });

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      const cart = await res.json();
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
      syncPanier(cart);
    } catch (e) {
      console.error('[GMP] Cart refresh error', e);
    }
  }

  /* Le tiroir est rendu en JS : il ne peut pas appeler `gmp-icon`, d'où cette
     copie de l'icône `trash` du snippet. Les deux doivent rester identiques. */
  const ICONE_CORBEILLE =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"' +
    ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="3 6 5 6 21 6"/>' +
    '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>' +
    '<line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';

  function renderCartDrawer(cart) {
    const itemsEl = $('#gmp-cart-drawer-items');
    const subtotalEl = $('#gmp-cart-drawer-subtotal');
    const footerEl = $('#gmp-cart-drawer-footer');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      const urlVide = (window.GMP_CART && window.GMP_CART.videUrl) || '/';
      itemsEl.innerHTML = '<p class="gmp-cart-drawer__empty">Votre panier est vide.</p>' +
        '<a class="gmp-btn gmp-btn--outline gmp-btn--sm gmp-cart-drawer__empty-cta" href="' + urlVide + '">Voir nos pièces</a>';
      if (footerEl) footerEl.hidden = true;
      return;
    }

    if (footerEl) footerEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="gmp-drawer-item" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_72x72.$1') : ''}"
             alt="${escapeHTML(item.title)}" width="72" height="72"
             onerror="this.style.display='none'">
        <div class="gmp-drawer-item__info">
          <p class="gmp-drawer-item__title">${escapeHTML(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="gmp-drawer-item__variant">${escapeHTML(item.variant_title)}</p>` : ''}
          <div class="gmp-drawer-item__row">
            <div class="gmp-qty-selector gmp-qty-selector--sm">
              <button type="button" class="gmp-qty-selector__btn" data-key="${item.key}" data-action="minus">−</button>
              <input type="number" value="${item.quantity}" min="0" data-key="${item.key}" class="gmp-qty-selector__input gmp-cart-qty" aria-label="Quantité">
              <button type="button" class="gmp-qty-selector__btn" data-key="${item.key}" data-action="plus">+</button>
            </div>
            <span class="gmp-drawer-item__price">${money(item.line_price)}</span>
            <button type="button" class="gmp-cart-item__remove" data-key="${item.key}"
                    aria-label="Retirer ${escapeHTML(item.product_title)} du panier"
                    title="Retirer du panier">${ICONE_CORBEILLE}</button>
          </div>
        </div>
      </div>
    `).join('');
  }

  function escapeHTML(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* Après un ajout : le tiroir s'ouvre, sauf si le marchand a coupé le réglage —
     sur un parcours où l'on ajoute plusieurs pièces d'affilée, l'ouverture
     systématique coupe la navigation à chaque fois. */
  async function apresAjoutPanier() {
    await refreshCartDrawer();
    if (window.GMP_CART && window.GMP_CART.autoOpen === false) return;
    openCartDrawer();
  }

  /* Note de commande — enregistrée en différé : un POST par frappe est inutile.
     Les deux champs (page panier et tiroir) sont resynchronisés après coup. */
  let _noteTimer = null;
  document.addEventListener('input', (e) => {
    const champ = e.target.closest && e.target.closest('.gmp-cart-note__field');
    if (!champ) return;
    const etat = champ.parentElement.querySelector('.gmp-cart-note__state');
    clearTimeout(_noteTimer);
    _noteTimer = setTimeout(async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: champ.value })
        });
        if (etat) { etat.hidden = false; setTimeout(() => { etat.hidden = true; }, 2500); }
        $$('.gmp-cart-note__field').forEach(autre => { if (autre !== champ) autre.value = champ.value; });
      } catch (err) { console.error('[GMP] Note de commande', err); }
    }, 700);
  });

  function updateCartCount(count) {
    $$('.gmp-header__cart-count').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ═══════════════════════════════════════════════════════
     QUANTITY SELECTORS (page panier + drawer)
     ═══════════════════════════════════════════════════════ */

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.gmp-qty-selector__btn');
    if (!btn) return;
    const action = btn.dataset.action;
    const key = btn.dataset.key;

    /* Sans `data-key`, on n'est pas dans le panier mais sur une fiche produit :
       le sélecteur pilote alors simplement le champ voisin, sans appel réseau.
       Ce cas manquait — les boutons + et − de la fiche produit ne faisaient
       rien, et seule la saisie clavier permettait de changer la quantité. */
    if (!key) {
      const champ = btn.closest('.gmp-qty-selector')?.querySelector('.gmp-qty-selector__input');
      if (!champ) return;
      const mini = parseInt(champ.getAttribute('min')) || 1;
      let n = parseInt(champ.value) || mini;
      n = action === 'plus' ? n + 1 : Math.max(mini, n - 1);
      champ.value = n;
      champ.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const input = document.querySelector(`.gmp-qty-selector__input[data-key="${key}"]`);
    if (!input) return;
    let qty = parseInt(input.value) || 0;
    if (action === 'plus') qty++;
    else if (action === 'minus') qty = Math.max(0, qty - 1);
    await updateCartItem(key, qty);
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('.gmp-cart-qty');
    if (!input) return;
    const key = input.dataset.key;
    const qty = Math.max(0, parseInt(input.value) || 0);
    await updateCartItem(key, qty);
  });

  async function updateCartItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      syncPanier(cart);

      // Mise à jour de la page panier si on y est
      if (document.querySelector('.gmp-cart-page')) {
        location.reload();
      }
      // Mise à jour du drawer si ouvert
      if (cartDrawer && cartDrawer.classList.contains('open')) {
        renderCartDrawer(cart);
      }
    } catch (e) {
      console.error('[GMP] Cart update error', e);
    }
  }

  /* ═══════════════════════════════════════════════════════
     REMOVE FROM CART
     ═══════════════════════════════════════════════════════ */

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.gmp-cart-item__remove');
    if (!btn) return;
    const key = btn.dataset.key;
    await updateCartItem(key, 0);
  });

  /* ═══════════════════════════════════════════════════════
     ADD TO CART (formulaire produit — AJAX)
     ═══════════════════════════════════════════════════════ */

  /* Délégation : fonctionne aussi pour les fiches injectées (panel inline, éclatés) */
  document.addEventListener('submit', async (e) => {
    const productForm = e.target.closest('#gmp-product-form, .gmp-product-info__form');
    if (!productForm) return;
    e.preventDefault();

    const btn = productForm.querySelector('[type="submit"]');
    // Scope au formulaire : plusieurs fiches peuvent coexister dans le DOM
    const variantId = productForm.querySelector('#gmp-variant-id, [name="id"]')?.value;
    const qty = productForm.querySelector('[name="quantity"]')?.value || 1;
    if (!variantId || !btn) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Ajout…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(qty) })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await res.json();

      btn.textContent = '✓ Ajouté !';
      btn.style.background = 'var(--gmp-green)';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);

      await apresAjoutPanier();

    } catch (err) {
      console.error('[GMP] Add to cart error', err);
      btn.textContent = 'Erreur, réessayez';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
    }
  });

  /* ═══════════════════════════════════════════════════════
     ADD TO CART — Fiches produit dans les grilles (AJAX)
     ═══════════════════════════════════════════════════════ */

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.gmp-product-card__form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Ajout…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      btn.textContent = '✓ Ajouté !';
      btn.style.background = 'var(--gmp-green)';
      setTimeout(() => { btn.textContent = originalText; btn.style.background = ''; btn.disabled = false; }, 2000);
      await apresAjoutPanier();
    } catch (err) {
      console.error('[GMP] Add to cart (card) error', err);
      btn.textContent = 'Erreur';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
    }
  });

  /* ═══════════════════════════════════════════════════════
     GALERIE PRODUIT — Miniatures
     ═══════════════════════════════════════════════════════ */

  /* ── Lightbox avec zoom & pan ── */
  let lightboxEl = null, lbImg = null;
  let lbScale = 1, lbTx = 0, lbTy = 0;
  let lbDragging = false, lbDragMoved = false, lbDragOrigin = null;
  /* Liste des photos de LA galerie d'où vient le clic, pour pouvoir défiler sans
     refermer. Reconstruite à chaque ouverture : la page produit et le panneau
     inline peuvent coexister dans le DOM, une liste figée montrerait les photos
     de l'autre fiche. */
  let lbList = [], lbIndex = 0, lbSwipe = null;
  /* Le glissement vit sur une COUCHE À PART (`__slide`), jamais sur l'image :
     `lbApply()` écrit déjà dans le `transform` de `lbImg` pour le zoom et le
     déplacement, et les deux se marcheraient dessus. */
  let lbSlideEl = null, lbAnim = null;

  function lbApply() {
    lbImg.style.transform = 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')';
    lbImg.classList.toggle('is-zoomed', lbScale > 1);
  }
  function lbClamp() {
    if (lbScale <= 1) { lbTx = 0; lbTy = 0; return; }
    var mx = (lbImg.offsetWidth * (lbScale - 1)) / 2;
    var my = (lbImg.offsetHeight * (lbScale - 1)) / 2;
    lbTx = Math.max(-mx, Math.min(mx, lbTx));
    lbTy = Math.max(-my, Math.min(my, lbTy));
  }

  function openLightbox(src, alt, list, index) {
    if (!lightboxEl) {
      lightboxEl = document.createElement('div');
      lightboxEl.className = 'gmp-lightbox';
      lightboxEl.setAttribute('role', 'dialog');
      lightboxEl.setAttribute('aria-modal', 'true');
      lightboxEl.innerHTML =
        '<button class="gmp-lightbox__close" aria-label="Fermer">&times;</button>' +
        '<button class="gmp-lightbox__nav gmp-lightbox__nav--prev" aria-label="Photo précédente">&#8249;</button>' +
        '<button class="gmp-lightbox__nav gmp-lightbox__nav--next" aria-label="Photo suivante">&#8250;</button>' +
        '<span class="gmp-lightbox__count" aria-live="polite"></span>' +
        '<div class="gmp-lightbox__wrap"><div class="gmp-lightbox__slide"><img class="gmp-lightbox__img" src="" alt="" draggable="false"></div></div>' +
        '<span class="gmp-lightbox__hint gmp-lightbox__hint--mouse">Molette pour zoomer \u00b7 Clic pour agrandir \u00b7 Fl\u00e8ches pour changer de photo</span>' +
        '<span class="gmp-lightbox__hint gmp-lightbox__hint--touch">Pincez pour zoomer \u00b7 Touchez pour agrandir \u00b7 Balayez pour changer de photo</span>';
      document.body.appendChild(lightboxEl);
      lbImg = lightboxEl.querySelector('.gmp-lightbox__img');
      lbSlideEl = lightboxEl.querySelector('.gmp-lightbox__slide');

      /* ⚠️ `stopPropagation` : le handler de fermeture ci-dessous se déclenche sur
         tout clic hors de l'image — sans ça, cliquer une flèche fermerait la
         lightbox au lieu de faire défiler. */
      lightboxEl.querySelectorAll('.gmp-lightbox__nav').forEach(function(b) {
        b.addEventListener('click', function(e) {
          e.stopPropagation();
          var d = b.classList.contains('gmp-lightbox__nav--next') ? 1 : -1;
          lbShow(lbIndex + d, d);
        });
      });

      lightboxEl.addEventListener('click', function(e) {
        if (e.target === lightboxEl || e.target.closest('.gmp-lightbox__wrap') === lightboxEl.querySelector('.gmp-lightbox__wrap') && e.target !== lbImg || e.target.matches('.gmp-lightbox__close'))
          closeLightbox();
      });
      document.addEventListener('keydown', function(e) {
        if (!lightboxEl || lightboxEl.hidden) return;
        if (e.key === 'Escape') { closeLightbox(); return; }
        if (lbList.length < 2) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbIndex + 1, 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbIndex - 1, -1); }
      });

      // Molette → zoom
      lightboxEl.querySelector('.gmp-lightbox__wrap').addEventListener('wheel', function(e) {
        e.preventDefault();
        var prev = lbScale;
        lbScale = Math.min(5, Math.max(1, lbScale + (e.deltaY < 0 ? 0.3 : -0.3)));
        if (lbScale !== prev) { lbClamp(); lbApply(); }
      }, { passive: false });

      // Clic image → zoom toggle
      lbImg.addEventListener('click', function(e) {
        e.stopPropagation();
        if (lbDragMoved) return;
        lbScale = lbScale < 1.5 ? 2.5 : 1;
        if (lbScale === 1) { lbTx = 0; lbTy = 0; }
        lbClamp(); lbApply();
      });

      // Drag → pan
      lbImg.addEventListener('mousedown', function(e) {
        if (lbScale <= 1) return;
        e.preventDefault();
        lbDragMoved = false;
        lbDragging = true;
        lbDragOrigin = { x: e.clientX - lbTx, y: e.clientY - lbTy };
        lbImg.classList.add('is-dragging');
      });
      document.addEventListener('mousemove', function(e) {
        if (!lbDragging) return;
        lbDragMoved = true;
        lbTx = e.clientX - lbDragOrigin.x;
        lbTy = e.clientY - lbDragOrigin.y;
        lbClamp(); lbApply();
      });
      document.addEventListener('mouseup', function() {
        if (!lbDragging) return;
        lbDragging = false;
        lbImg.classList.remove('is-dragging');
        setTimeout(function() { lbDragMoved = false; }, 0);
      });

      // Tactile → pincer pour zoomer, glisser pour déplacer
      var wrapEl = lightboxEl.querySelector('.gmp-lightbox__wrap');
      var lbPinchDist = 0, lbPinchScale = 1, lbTouchOrigin = null;

      wrapEl.addEventListener('touchstart', function(e) {
        if (e.touches.length === 2) {
          lbPinchDist  = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          lbPinchScale = lbScale;
          lbTouchOrigin = null;
          lbDragMoved = true; // un pinch ne doit pas déclencher le clic-zoom
        } else if (e.touches.length === 1) {
          lbTouchOrigin = { x: e.touches[0].clientX - lbTx, y: e.touches[0].clientY - lbTy };
          lbSwipe = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
      }, { passive: true });

      wrapEl.addEventListener('touchmove', function(e) {
        if (e.touches.length === 2 && lbPinchDist > 0) {
          e.preventDefault();
          var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          lbScale = Math.min(5, Math.max(1, lbPinchScale * d / lbPinchDist));
          lbClamp(); lbApply();
        } else if (e.touches.length === 1 && lbScale > 1 && lbTouchOrigin) {
          e.preventDefault();
          lbDragMoved = true;
          lbTx = e.touches[0].clientX - lbTouchOrigin.x;
          lbTy = e.touches[0].clientY - lbTouchOrigin.y;
          lbClamp(); lbApply();
        }
      }, { passive: false });

      wrapEl.addEventListener('touchend', function(e) {
        if (e.touches.length < 2) lbPinchDist = 0;
        if (e.touches.length === 0) {
          /* ⚠️ Le balayage ne change de photo QUE si l'image n'est pas zoomée :
             au-delà de l'échelle 1 le même geste sert à déplacer l'image, et
             changer de photo sous le doigt du client serait incompréhensible.
             Seuil de 45 px et geste franchement horizontal (|dx| > |dy|), sinon
             un défilement vertical hésitant ferait sauter une photo. */
          if (lbSwipe && lbScale <= 1 && lbList.length > 1 && e.changedTouches[0]) {
            var dx = e.changedTouches[0].clientX - lbSwipe.x;
            var dy = e.changedTouches[0].clientY - lbSwipe.y;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
              lbDragMoved = true;               // ce geste n'est pas un clic-zoom
              var sd = dx < 0 ? 1 : -1;
              lbShow(lbIndex + sd, sd);
            }
          }
          lbSwipe = null;
          lbTouchOrigin = null;
          setTimeout(function() { lbDragMoved = false; }, 350);
        }
      });
    }

    lbList  = Array.isArray(list) && list.length ? list : [{ src: src, alt: alt }];
    lbShow(index || 0);
    lightboxEl.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  /* Pose la photo `i` : source, compteur, flèches, préchargement des voisines.
     Sans animation — c'est `lbShow` qui l'habille. */
  function lbRender(i) {
    if (!lbList.length || !lightboxEl) return;
    lbIndex = ((i % lbList.length) + lbList.length) % lbList.length;
    var it = lbList[lbIndex];
    lbImg.src = it.src;
    lbImg.alt = it.alt || '';
    lbScale = 1; lbTx = 0; lbTy = 0;
    lbApply();
    var seul = lbList.length < 2;
    var cnt = lightboxEl.querySelector('.gmp-lightbox__count');
    if (cnt) { cnt.textContent = (lbIndex + 1) + ' / ' + lbList.length; cnt.hidden = seul; }
    lightboxEl.querySelectorAll('.gmp-lightbox__nav').forEach(function(b) { b.hidden = seul; });
    /* Précharge les deux voisines : sans ça le passage à la photo suivante
       affiche un cadre vide et le geste paraît raté — et l'animation de
       glissement ferait défiler du blanc. */
    if (!seul) {
      [lbIndex + 1, lbIndex - 1].forEach(function(k) {
        var v = lbList[((k % lbList.length) + lbList.length) % lbList.length];
        if (v) { var im = new Image(); im.src = v.src; }
      });
    }
  }

  /* Affiche la photo `i` de `lbList`, en boucle : depuis la dernière, « suivant »
     revient à la première. `dir` (+1 suivant, -1 précédent) déclenche le
     glissement ; sans lui — à l'ouverture — la photo est posée sans animation. */
  function lbShow(i, dir) {
    if (!lbList.length || !lightboxEl) return;
    var anime = dir
      && lbSlideEl
      && lbList.length > 1
      /* ⚠️ Respecter `prefers-reduced-motion` : le mouvement latéral est
         exactement le genre d'animation qui gêne les personnes qui l'ont
         désactivé. On retombe alors sur un changement instantané. */
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Une animation déjà en cours est coupée net : sur des clics rapides, mieux
       vaut un défilement sec qu'une file d'animations qui se chevauchent et
       laissent la couche à mi-course. */
    if (lbAnim) { clearTimeout(lbAnim); lbAnim = null; lbSlideReset(); if (anime) anime = false; }

    if (!anime) { lbRender(i); return; }

    var d = dir > 0 ? 1 : -1;
    lbSlideEl.style.transition = 'transform .14s ease-in, opacity .14s ease-in';
    lbSlideEl.style.transform  = 'translateX(' + (-d * 40) + 'px)';
    lbSlideEl.style.opacity    = '0';
    lbAnim = setTimeout(function() {
      lbRender(i);
      /* La nouvelle photo est placée de l'autre côté SANS transition, puis on
         force un reflow avant de la ramener : sans cette lecture, le navigateur
         regroupe les deux écritures et l'image apparaît sans glisser. */
      lbSlideEl.style.transition = 'none';
      lbSlideEl.style.transform  = 'translateX(' + (d * 40) + 'px)';
      void lbSlideEl.offsetWidth;
      lbSlideEl.style.transition = 'transform .22s cubic-bezier(.22,.61,.36,1), opacity .22s ease-out';
      lbSlideEl.style.transform  = 'translateX(0)';
      lbSlideEl.style.opacity    = '1';
      lbAnim = setTimeout(function() { lbAnim = null; lbSlideReset(); }, 230);
    }, 140);
  }

  function lbSlideReset() {
    if (!lbSlideEl) return;
    lbSlideEl.style.transition = '';
    lbSlideEl.style.transform  = '';
    lbSlideEl.style.opacity    = '';
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.hidden = true;
    document.body.style.overflow = '';
  }

  function initProductGallery(scope) {
    const ctx = scope || document;
    [...ctx.querySelectorAll('.gmp-product-gallery__image')].forEach(img => {
      img.addEventListener('click', () => {
        /* La liste vient de `closest`, pas du `scope` : la page produit et le
           panneau inline coexistent dans le DOM, et une liste bâtie sur le scope
           mélangerait les photos des deux fiches. Les vidéos en sont exclues
           d'office — le sélecteur ne prend que `__image`, et la lightbox ne sait
           afficher qu'une image. */
        const gal = img.closest('.gmp-product-gallery');
        const imgs = gal ? [...gal.querySelectorAll('.gmp-product-gallery__image')] : [img];
        const list = imgs.map(el => ({ src: el.dataset.zoomSrc || el.src, alt: el.alt }));
        openLightbox(img.dataset.zoomSrc || img.src, img.alt, list, imgs.indexOf(img));
      });
    });
  }

  initProductGallery(null);

  /* ═══════════════════════════════════════════════════════
     SÉLECTEUR DE VARIANTS (page produit)
     ═══════════════════════════════════════════════════════ */

  function updatePriceBlock(variant, priceBlock, atcBtn) {
    if (!priceBlock) return;
    const price = money(variant.price);
    const compareAt = variant.compare_at_price;
    // Structure identique au Liquid de gmp-product.liquid (remise en %)
    if (compareAt && compareAt > variant.price) {
      const pct = Math.round((compareAt - variant.price) / compareAt * 100);
      priceBlock.innerHTML = `
        <div class="gmp-product-info__price-row">
          <span class="gmp-product-info__price--sale">${price}</span>
          <s class="gmp-product-info__price--compare">${money(compareAt)}</s>
          <span class="gmp-product-info__price--saving">− ${pct} %</span>
        </div>
        <span class="gmp-product-info__price--tax">TTC · Livraison calculée à la commande</span>
      `;
    } else {
      priceBlock.innerHTML = `
        <span class="gmp-product-info__price--regular">${price}</span>
        <span class="gmp-product-info__price--tax">TTC · Livraison calculée à la commande</span>
      `;
    }
    /* ⚠️ **NE PAS ÉCRIRE DANS `textContent` DU BOUTON** : il contient l'icône de
       panier en SVG inline, et `textContent =` la détruisait au premier changement
       de variante — l'icône ne revenait jamais, même en revenant sur la variante
       de départ. Le Liquid rend donc le libellé dans un `<span>` dédié, toujours
       présent, et l'icône est masquée par le CSS quand le bouton est désactivé.
       Le repli sur `textContent` ne sert qu'aux fiches d'un cache ancien. */
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      const texte = variant.available ? 'Ajouter au panier' : 'Indisponible';
      const lbl = atcBtn.querySelector('.gmp-product-info__atc-label');
      if (lbl) lbl.textContent = texte; else atcBtn.textContent = texte;
    }
  }

  /* ⚠️ **LA GALERIE SUIT LA VARIANTE** (11/09/2026, demande du marchand : « même
     switch les photos »). Le média de la variante est **déplacé en tête du DOM**,
     pas mis en avant par `order` : la lightbox construit sa liste depuis l'ordre
     du DOM (`img.closest('.gmp-product-gallery')`) et le carrousel mobile défile
     sur ce même ordre — un ordre purement visuel leur mentirait, le compteur
     annonçant « 3 / 17 » sur la photo affichée en premier.
     ⚠️ Seul le nœud déplacé est re-parenté : une vidéo en cours de lecture ailleurs
     dans la galerie n'est pas réinitialisée.
     ⚠️ La photo remontée peut être en `loading="lazy"` — elle ne se serait jamais
     chargée si elle restait sous la ligne de flottaison, d'où le passage en
     `eager` : la variante choisie ne doit pas afficher un cadre vide. */
  function montrerMediaVariante(ctx, mediaId) {
    if (!mediaId) return;
    const galerie = (ctx || document).querySelector('.gmp-product-gallery');
    if (!galerie) return;
    const item = galerie.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item || item === galerie.firstElementChild) return;
    galerie.prepend(item);
    galerie.querySelectorAll('.gmp-product-gallery__item--featured')
           .forEach(e => e.classList.remove('gmp-product-gallery__item--featured'));
    item.classList.add('gmp-product-gallery__item--featured');
    const img = item.querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
    /* Carrousel mobile : sans ce retour à zéro, la photo de la variante est bien
       en première position mais le doigt reste sur celle d'avant. `auto` et non
       `smooth` — un défilement animé à chaque clic de variante donne le tournis. */
    if (galerie.scrollWidth > galerie.clientWidth + 4) galerie.scrollLeft = 0;
  }

  /* L'URL porte la variante choisie, comme sur toute boutique Shopify : un lien
     partagé, un favori ou un rechargement rouvrent la bonne.
     ⚠️ **`replaceState`, et sur la fiche AUTONOME seulement.** Dans un panneau
     inline l'URL appartient à `_gmpNav` (`?l2=&z=&l3=&p=`) : y pousser une entrée
     d'historique casserait le bouton retour, qui est tout le contrat de la
     navigation inline. `template-product` est le seul cas où la page EST la fiche. */
  function majUrlVariante(id) {
    if (!document.body.classList.contains('template-product')) return;
    try {
      const u = new URL(location.href);
      u.searchParams.set('variant', id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* URL exotique : l'adresse n'est pas un motif d'échec */ }
  }

  function initProductVariants(scope, productData) {
    const ctx = scope || document;
    const variantBtns = [...ctx.querySelectorAll('.gmp-variant-btn')];
    const variantIdInput = ctx.querySelector('#gmp-variant-id');
    const priceBlock = ctx.querySelector('#gmp-product-price');
    const data = productData || window.GMP_PRODUCT;
    if (!variantBtns.length || !data) return;
    const variants = data.variants || [];
    if (!variants.length) return;

    const atcBtn  = ctx.querySelector('.gmp-product-info__atc');
    const stockEl = ctx.querySelector('#gmp-stock-indicator');
    const medias  = data.media || {};

    /* ⚠️ **L'ÉTAT DE DÉPART SE LIT SUR LE FORMULAIRE, JAMAIS SUR `variants[0]`.**
       Le Liquid y a posé `selected_or_first_available_variant`, qui n'est la
       première variante que tant que celle-ci est vendable. Partir de
       `variants[0]` désynchronisait la sélection du JS de ce qui était affiché :
       sur un produit à deux options dont la 1re variante est épuisée, le premier
       clic recomposait une combinaison qui n'avait jamais été à l'écran. */
    const idInit = variantIdInput ? parseInt(variantIdInput.value, 10) : 0;
    let courante = variants.find(v => v.id === idInit)
                || variants.find(v => v.available)
                || variants[0];

    const selection = {};
    const poser = v => v.options.forEach((val, i) => { selection[i + 1] = val; });

    /* ⚠️ La correspondance est EXACTE sur toutes les options. L'ancien test
       acceptait `!(pos in selectedOptions)`, donc une option non encore touchée
       passait pour « n'importe quelle valeur » : sur un produit à deux options,
       `find` renvoyait la première variante venue — pas celle que le client avait
       sous les yeux. */
    const exacte = opts => variants.find(v => v.options.every((val, i) => opts[i + 1] === val));

    /* ⚠️ **ON MARQUE, ON NE DÉSACTIVE PAS.** Une variante épuisée doit rester
       ouvrable : c'est là que le client lit « Rupture de stock » et trouve le
       formulaire de veille (« prévenez-moi quand elle rentre »). La classe
       `unavailable` existait déjà dans `gmp.css` sans être posée nulle part —
       encore une classe morte, comme celles de la carte produit. */
    function marquerDispo() {
      variantBtns.forEach(b => {
        const pos = parseInt(b.dataset.option, 10);
        const essai = Object.assign({}, selection);
        essai[pos] = b.dataset.value;
        const v = exacte(essai);
        b.classList.toggle('unavailable', !(v && v.available));
      });
    }

    function appliquer(v, majUrl) {
      courante = v;
      poser(v);
      variantBtns.forEach(b => {
        const actif = selection[parseInt(b.dataset.option, 10)] === b.dataset.value;
        b.classList.toggle('selected', actif);
        b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      marquerDispo();
      if (variantIdInput) variantIdInput.value = v.id;
      updatePriceBlock(v, priceBlock, atcBtn);
      /* On passe l'objet produit entier : `updateStockIndicator` a besoin des
         quatre tables (policies, quantities, management, appro), aucune n'étant
         sérialisée sur la variante elle-même.
         ⚠️ **`data`, JAMAIS `productData`.** `productData` est le PARAMÈTRE de
         `initProductVariants`, et il vaut `null` sur une fiche autonome — l'appel
         est `initProductVariants(null, null)`, les tables ne venant alors que du
         repli `window.GMP_PRODUCT` rangé dans `data`. `updateStockIndicator`
         sortait donc sur son `if (!stockEl || !data) return;` : la pastille ne
         changeait JAMAIS au changement de variante sur une fiche autonome, alors
         qu'elle changeait dans le panneau inline (qui, lui, reçoit un
         `productData`). Rien ne le signalait — pas d'erreur, et le prix se mettait
         à jour normalement à côté. Mesuré le 09/09/2026 sur
         `clignotant-avant-gauche-arriere-droit-ducati-superbike-sbk-748-1996` : la
         variante Occasion (1 en stock) gardait « Disponible sur commande ». */
      updateStockIndicator(v, stockEl, data);
      montrerMediaVariante(ctx, medias[v.id]);
      if (majUrl) majUrlVariante(v.id);
    }

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = parseInt(btn.dataset.option, 10);
        const essai = Object.assign({}, selection);
        essai[pos] = btn.dataset.value;
        let v = exacte(essai);
        if (!v) {
          /* La combinaison n'existe pas au catalogue : on garde la valeur que le
             client vient de choisir — c'est son intention — et on bascule les
             autres options sur une variante qui existe, vendable de préférence.
             Ne rien faire laisserait un bouton qui ne répond pas au clic, ce que
             personne ne lit comme « cette combinaison n'existe pas ». */
          const cands = variants.filter(x => x.options[pos - 1] === btn.dataset.value);
          v = cands.find(x => x.available) || cands[0];
        }
        if (v) appliquer(v, true);
      });
    });

    /* ⚠️ **L'ÉTAT DE DÉPART EST RÉAPPLIQUÉ, il n'est pas supposé.** Le Liquid rend
       déjà prix, pastille et bouton pour cette variante ; ce passage ne sert qu'à
       poser ce que le Liquid ne sait pas faire — les valeurs indisponibles (qui
       demandent de recouper plusieurs options) et la photo de la variante. Il est
       idempotent : les deux rendus disent la même chose, et depuis que `money()`
       lit le format de la boutique, au caractère près. */
    appliquer(courante, false);
  }

  function updateStockIndicator(variant, stockEl, data) {
    if (!stockEl || !data) return;
    let cls, text;
    /* ⚠️ Ni `inventory_policy` ni `inventory_quantity` ne sont sérialisés par
       `variant | json` : ils arrivent absents ou nuls. Tout se lit donc dans les
       tables posées par le Liquid (`policies`, `quantities`, `management`), et
       jamais sur `variant` directement — la comparaison portait sur `undefined`,
       et « 1 restant » ne s'affichait donc jamais au changement de variante. */
    const policy = (data.policies || {})[variant.id];
    const qte    = (data.quantities || {})[variant.id];
    const suivi  = (data.management || {})[variant.id] === 'shopify';

    /* La survente autorisée ne veut PAS dire « nous ne l'avons pas » : elle dit
       que le fournisseur peut suivre. Tant qu'il en reste chez NOUS, c'est du
       stock, et ça se dit — `bouchon-alu-crepine-neuf-ducati` en avait 23 et
       annonçait « Commandé chez Ducati ». `qte` est le stock de Gers Moto Pièces
       seul : les emplacements fournisseurs ne sont pas publiés sur la boutique
       en ligne, le storefront ne les voit pas.
       Le libellé vient du Liquid (`data-cmd-label`) : « Commandé chez Ducati »
       sur une pièce d'ORIGINE seulement, « Disponible sur commande » partout
       ailleurs — adaptables d'équipementier (détectés sur le SKU, BIHR/BHIR/BHR),
       MOTUL, batteries, outillage.
       ⚠️ « Ducati » DANS LE TITRE NE VEUT PAS DIRE PIÈCE D'ORIGINE : sur une
       pièce d'équipementier le titre nomme la MOTO compatible. C'est pourquoi le
       Liquid teste le SKU avant le titre — 3 fiches disaient « Commandé chez
       Ducati » sur des pièces Bihr et Brembo au 08/09/2026.
       ⚠️ Le repli ci-dessous porte la MÊME chaîne que le défaut du Liquid : les
       deux se modifient ensemble. L'ancien « Sur commande » a été supprimé le
       08/09/2026, deux formulations pour le même fait ne se distinguant par rien
       que le client puisse lire. */
    /* Bihr / Motul en tiennent : fournisseurs d'approvisionnement courant, ça se
       vend comme du stock. Marqueur posé par `server/stock_appro.py` — le
       storefront ne voit que le stock de Gers Moto Pièces, les emplacements
       fournisseurs ayant « expédie du stock » décoché. */
    const chezFournisseur = (data.appro || {})[variant.id] === 'fournisseur';

    /* `gmp.ducati` : ce que Ducati peut reellement fournir, pose chaque nuit par
       server/dispo_shopify.py. `rupture` = toujours au catalogue mais sans stock
       usine. La vente reste ouverte (Ducati honore avec un delai plus long),
       mais la pastille seule laisserait croire a une expedition sous 72 h. */
    const enRupture = (data.ducati || {})[variant.id] === 'rupture';

    if (policy === 'continue' && suivi && qte <= 0 && !chezFournisseur) {
      cls = 'gmp-stock--cmd';
      text = stockEl.dataset.cmdLabel || 'Disponible sur commande';
    } else if (!variant.available) {
      cls = 'gmp-stock--out'; text = 'Rupture de stock';
    } else if (suivi && qte === 1) {
      cls = 'gmp-stock--low'; text = '1 restant';
    } else {
      cls = 'gmp-stock--ok'; text = 'En stock';
    }
    stockEl.innerHTML = '<span class="gmp-stock ' + cls + '">' + text + '</span>';
    /* La note est rendue par le Liquid et seulement montree/cachee ici : une
       seule redaction du texte, impossible qu'elle diverge entre le premier
       affichage et un changement de variante. */
    const note = document.getElementById('gmp-stock-note');
    const enCmd = cls === 'gmp-stock--cmd';
    if (note) note.hidden = !(enRupture && enCmd);

    /* ⚠️ Le cadre de retrait ne peut pas annoncer « prete en 24 heures » sur une
       piece qu'il faut d'abord commander : `store_availabilities` la declare
       « disponible au retrait » des que la survente est autorisee, meme a zero.
       Les deux redactions sont rendues par le Liquid, on ne fait que montrer
       l'une ou l'autre — meme motif que la note ci-dessus.
       ⚠️ Portee au `.gmp-product-info` de CETTE fiche, jamais `document` : la page
       produit et le panneau inline coexistent dans le DOM, et un getElementById
       toucherait le cadre de l'autre fiche. */
    const zone = stockEl.closest('.gmp-product-info');
    if (zone) {
      const pStock = zone.querySelector('#gmp-pickup-stock');
      const pCmd   = zone.querySelector('#gmp-pickup-cmd');
      const pDelai = zone.querySelector('#gmp-pickup-delai');
      const pBox   = zone.querySelector('.gmp-product-info__pickup');
      if (pStock) pStock.hidden = enCmd;
      if (pCmd)   pCmd.hidden   = !enCmd;
      /* Rupture chez Ducati : la note dit deja que le delai reste a confirmer,
         annoncer 72 h en meme temps la contredirait. */
      if (pDelai) pDelai.hidden = enRupture;
      if (pBox)   pBox.classList.toggle('gmp-product-info__pickup--cmd', enCmd);
      /* ⚠️ Variante epuisee : aucun retrait a promettre, l'emplacement reste
         pourtant liste dans `store_availabilities`. Le Liquid rend le cadre
         `hidden` au premier affichage, on rejoue la meme regle ici. */
      if (pBox)   pBox.hidden = !variant.available;
    }
  }

  initProductVariants(null, null);

  /* ═══════════════════════════════════════════════════════
     ZONE TOGGLES — Accordion (L2 + panel L1 injecté)
     ═══════════════════════════════════════════════════════ */

  const stickyHeader = document.getElementById('gmp-header');

  function scrollToEl(el) {
    requestAnimationFrame(() => {
      const headerH = stickyHeader ? stickyHeader.offsetHeight : 60;
      const top = el.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  /* Ajoute un bouton "Retour" en bas d'une grille expandée */
  function addBackBtn(grid, label, scrollTarget) {
    if (grid.querySelector('.gmp-back-btn')) return; // déjà présent
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gmp-back-btn';
    btn.innerHTML = '&#8679; ' + label;
    btn.addEventListener('click', () => scrollToEl(scrollTarget));
    grid.appendChild(btn);
  }

  /* ═══════════════════════════════════════════════════════
     INFINITE SCROLL — charge les produits au défilement
     ═══════════════════════════════════════════════════════ */

  function initInfiniteScroll(scope) {
    const sentinel = scope ? scope.querySelector('.gmp-load-sentinel') : document.querySelector('.gmp-load-sentinel');
    if (!sentinel) return;

    const grid = scope ? scope.querySelector('#gmp-product-grid') : document.getElementById('gmp-product-grid');
    if (!grid) return;

    let loading = false;

    const observer = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading) return;
      loading = true;

      const handle   = sentinel.dataset.handle;
      const nextPage = parseInt(sentinel.dataset.nextPage);
      const total    = parseInt(sentinel.dataset.totalPages);
      const sort     = sentinel.dataset.sort || '';
      const filterQs = scope ? (scope.dataset.filterQs || '') : _locationFilterQs();

      try {
        let url = '/collections/' + handle + '?page=' + nextPage + '&sections=gmp-collection';
        if (sort) url += '&sort_by=' + sort;
        if (filterQs) url += '&' + filterQs;

        const res = await fetch(url);
        if (!res.ok) throw new Error('fetch ' + res.status);
        const data = await res.json();
        const html = data['gmp-collection'];
        if (!html) throw new Error('section absente');

        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Extraire les cartes produits de la page suivante
        const newGrid = tmp.querySelector('#gmp-product-grid');
        if (newGrid) {
          while (newGrid.firstChild) {
            grid.appendChild(document.adoptNode(newGrid.firstChild));
          }
        }

        // Y a-t-il encore une page après ?
        const nextSentinel = tmp.querySelector('.gmp-load-sentinel');
        if (nextSentinel && nextPage < total) {
          sentinel.dataset.nextPage = nextPage + 1;
          loading = false; // prêt pour la prochaine page
        } else {
          observer.disconnect();
          sentinel.remove();
        }

      } catch (err) {
        console.error('[GMP] infinite scroll error', err);
        observer.disconnect();
        sentinel.remove();
      }
    }, { rootMargin: '200px' });

    observer.observe(sentinel);
  }

  /* ── Sérialise les champs filter.* non vides d'un formulaire de filtres ── */
  function _serializeFilters(form) {
    const params = new URLSearchParams();
    [...form.elements].forEach(el => {
      if (!el.name || el.disabled) return;
      if (el.name.indexOf('filter.') !== 0) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '') return;
      params.append(el.name, el.value);
    });
    return params.toString();
  }

  /* ── Params filter.* de l'URL courante (pages standalone) ── */
  function _locationFilterQs() {
    const out = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach((v, k) => {
      if (k.indexOf('filter.') === 0) out.append(k, v);
    });
    return out.toString();
  }

  /* ── Charge et injecte une page produits dans productsPanel ── */
  async function loadProducts(handle, sortBy, productsPanel, parentGrid, filterQs) {
    let url = '/collections/' + handle + '?sections=gmp-collection';
    if (sortBy) url += '&sort_by=' + sortBy;
    if (filterQs) url += '&' + filterQs;
    productsPanel.dataset.filterQs = filterQs || '';

    const res = await fetch(url);
    if (!res.ok) throw new Error('fetch ' + res.status);
    const data = await res.json();
    const html = data['gmp-collection'];
    if (!html) throw new Error('section absente');

    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const l3container = tmp.querySelector('.gmp-collection-page--products .gmp-container');
    if (!l3container) {
      productsPanel.innerHTML = '<p class="gmp-l1-error">Produits indisponibles.</p>';
      return;
    }

    // Bouton retour
    const backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'gmp-back-btn gmp-back-btn--top';
    backBtn.innerHTML = '&#8679; Retour aux catégories';
    backBtn.addEventListener('click', () => history.back());

    productsPanel.innerHTML = '';
    productsPanel.appendChild(backBtn);
    while (l3container.firstChild) {
      productsPanel.appendChild(document.adoptNode(l3container.firstChild));
    }

    // Intercepter le tri pour rester en inline (en conservant les filtres actifs)
    const sortSelect = productsPanel.querySelector('#gmp-sort');
    if (sortSelect) {
      sortSelect.removeAttribute('onchange');
      sortSelect.addEventListener('change', async () => {
        const newSort = new URLSearchParams(sortSelect.value.replace(/^\?/, '')).get('sort_by') || '';
        const grid = productsPanel.querySelector('#gmp-product-grid');
        if (grid) grid.style.opacity = '.4';
        try {
          await loadProducts(handle, newSort, productsPanel, parentGrid, productsPanel.dataset.filterQs || '');
        } catch (e) {
          console.error('[GMP] sort reload error', e);
        }
      });
    }

    // Intercepter les filtres pour rester en inline
    const filtersForm = productsPanel.querySelector('#gmp-filters-form');
    if (filtersForm) {
      const currentSort = () => {
        const s = productsPanel.querySelector('#gmp-sort');
        return s ? (new URLSearchParams(s.value.replace(/^\?/, '')).get('sort_by') || '') : '';
      };
      filtersForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        try {
          await loadProducts(handle, currentSort(), productsPanel, parentGrid, _serializeFilters(filtersForm));
        } catch (err) {
          console.error('[GMP] filters reload error', err);
        }
      });
      const clearLink = productsPanel.querySelector('.gmp-filters__clear');
      if (clearLink) {
        clearLink.addEventListener('click', async (e) => {
          e.preventDefault();
          try {
            await loadProducts(handle, currentSort(), productsPanel, parentGrid, '');
          } catch (err) {
            console.error('[GMP] filters clear error', err);
          }
        });
      }
    }

    initInfiniteScroll(productsPanel);
    initProductCards(productsPanel);
  }

  /* ── Catégories → charge les produits en panel inline (AJAX) ── */
  function initCatCards(scope) {
    const cards = scope ? [...scope.querySelectorAll('.gmp-cat-card')] : $$('.gmp-cat-card');
    const productsPanel = scope
      ? scope.querySelector('#gmp-products-panel')
      : document.getElementById('gmp-products-panel');

    cards.forEach(card => {
      card.addEventListener('click', async (e) => {
        const handle = card.getAttribute('data-col-handle');
        const href = card.getAttribute('data-nav-href') || (handle && '/collections/' + handle);
        if (!href) return;

        /* ⚠️ Une carte peut être un vrai <a> (passerelle Entretiens) ou un
           <div role="button"> (zones de la page modèle). Sur un lien, on laisse
           passer le clic milieu et les clics avec modificateur : « ouvrir dans
           un nouvel onglet » doit continuer de marcher, c'est ce qu'on gagne à
           garder un href plutôt qu'un div. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

        if (productsPanel && handle) {
          e.preventDefault();
          cards.forEach(c => c.classList.remove('active'));
          card.classList.add('active');

          const parentGrid = card.closest('.gmp-pieces-grid, .gmp-entretiens-grid, .gmp-accessoires-grid');

          productsPanel.hidden = false;
          productsPanel.innerHTML = '<div class="gmp-l1-loading"><span></span> Chargement…</div>';
          scrollToEl(productsPanel);

          try {
            await loadProducts(handle, null, productsPanel, parentGrid);
            pushGmpState({ l3: handle, p: null });
          } catch (err) {
            console.error('[GMP] catCard load error', err);
            productsPanel.innerHTML = '<p class="gmp-l1-error">Erreur de chargement.</p>';
          }
        } else if (card.tagName !== 'A') {
          /* Sur un <a>, on ne fait rien : le navigateur suit son href tout seul,
             et lui voler la navigation casserait l'ouverture en nouvel onglet. */
          window.location.href = href;
        }
      });
    });
  }

  function initZoneToggles(scope) {
    const qs  = sel => scope ? scope.querySelector(sel)  : document.querySelector(sel);
    const zonesEl = qs('.gmp-zones');

    const toggles = [
      { btn: qs('[data-zone-toggle="pieces"]'),      grid: qs('#gmp-pieces-grid'),      zone: 'pieces' },
      { btn: qs('[data-zone-toggle="accessoires"]'), grid: qs('#gmp-accessoires-grid'), zone: 'accessoires' },
      { btn: qs('[data-zone-toggle="entretiens"]'),  grid: qs('#gmp-entretiens-grid'),  zone: 'entretiens' },
    ].filter(z => z.btn && z.grid);

    toggles.forEach(({ btn, grid, zone }) => {
      btn.addEventListener('click', () => {
        const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
        toggles.forEach(({ btn: b, grid: g }) => {
          b.setAttribute('aria-expanded', 'false');
          g.hidden = true;
        });
        const pp = (scope || document).querySelector('#gmp-products-panel');
        if (pp) { pp.hidden = true; pp.innerHTML = ''; }
        (scope || document).querySelectorAll('.gmp-cat-card.active').forEach(c => c.classList.remove('active'));
        if (!wasExpanded) {
          btn.setAttribute('aria-expanded', 'true');
          grid.hidden = false;
          addBackBtn(grid, 'Retour aux catégories', zonesEl || btn);
          scrollToEl(grid);
          pushGmpState({ zone: zone, l3: null, p: null });
        }
      });
    });
  }

  /* ── Bouton retour navigateur ── */
  window.addEventListener('popstate', (e) => {
    /* Panel article (URL réelle via pushState) */
    const articlePanel = document.getElementById('gmp-article-panel');
    if (articlePanel && !articlePanel.hidden) {
      closeArticlePanel(document.querySelector('.gmp-blog-card.active'));
      return;
    }

    const target = (e.state && e.state.gmpNav)
      ? e.state.gmpNav
      : { l2: null, zone: null, l3: null, p: null };
    const from = _gmpNav;
    _gmpNav = target;
    _applyNavState(target, from);
  });

  /* ═══════════════════════════════════════════════════════
     PAGE PRODUIT — Panneau inline (navigation catégories)
     ═══════════════════════════════════════════════════════ */

  async function loadProductInPanel(productUrl, panel, skipHistory = false) {
    panel.hidden = false;
    panel.innerHTML = '<div class="gmp-l1-loading"><span></span> Chargement…</div>';
    scrollToEl(panel);

    const res = await fetch(productUrl + '?sections=gmp-product');
    if (!res.ok) throw new Error('fetch ' + res.status);
    const data = await res.json();
    const html = data['gmp-product'];
    if (!html) throw new Error('section absente');

    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // Extraire les données variants depuis la balise <script>
    let productData = null;
    const scriptEl = tmp.querySelector('script');
    if (scriptEl) {
      const match = scriptEl.textContent.match(/window\.GMP_PRODUCT\s*=\s*(\{[\s\S]*?\});/);
      if (match) {
        try { productData = JSON.parse(match[1]); }
        catch (e) {
          /* Sans données, aucun écouteur n'est posé et les boutons de variante
             restent inertes. L'échec doit être visible, pas silencieux. */
          console.error('[GMP] window.GMP_PRODUCT illisible dans le panneau produit', e);
        }
      }
    }

    const productEl = tmp.querySelector('.gmp-product-page');

    // Carte détachée : en-tête (retour + fermer) puis fiche produit
    const card = document.createElement('div');
    card.className = 'gmp-panel-card';

    const head = document.createElement('div');
    head.className = 'gmp-panel-card__head';

    const backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'gmp-panel-card__back';
    backBtn.innerHTML = '&#8592; Retour aux produits';
    backBtn.addEventListener('click', () => history.back());

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'gmp-panel-card__close';
    closeBtn.setAttribute('aria-label', 'Fermer la fiche produit');
    closeBtn.innerHTML = '&#10005;';
    closeBtn.addEventListener('click', () => history.back());

    head.appendChild(backBtn);
    head.appendChild(closeBtn);
    card.appendChild(head);
    if (productEl) card.appendChild(document.adoptNode(productEl));

    panel.innerHTML = '';
    panel.appendChild(card);

    initProductGallery(panel);
    if (productData) initProductVariants(panel, productData);
    initVeilleConteneurs(panel);

    if (!skipHistory) {
      const productHandle = productUrl.replace(/^\/products\//, '').replace(/[?#].*$/, '');
      pushGmpState({ p: productHandle });
    }
    scrollToEl(panel);
  }

  function initProductCards(scope) {
    const ctx = scope || document;
    const panel = ctx.querySelector('#gmp-product-panel');
    if (!panel) return;

    const cards = [...ctx.querySelectorAll('.gmp-product-card')];
    cards.forEach(card => {
      const productUrl = card.getAttribute('data-product-url');
      if (!productUrl) return;

      card.querySelectorAll('.gmp-product-card__image-link, .gmp-product-card__title').forEach(link => {
        link.addEventListener('click', async (e) => {
          e.preventDefault();
          const headerH = stickyHeader ? stickyHeader.offsetHeight : 60;
          _productScrollTarget = card.getBoundingClientRect().top + window.scrollY - headerH - 12;
          cards.forEach(c => c.classList.remove('active'));
          card.classList.add('active');
          try {
            await loadProductInPanel(productUrl, panel);
          } catch(err) {
            console.error('[GMP] product panel load error', err);
            panel.innerHTML = '<p class="gmp-l1-error">Erreur de chargement.</p>';
          }
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     BLOG — Chargement d'article en panneau inline
     ═══════════════════════════════════════════════════════ */

  function closeArticlePanel(activeCard) {
    const panel = document.getElementById('gmp-article-panel');
    if (!panel) return;
    panel.hidden = true;
    panel.innerHTML = '';
    $$('.gmp-blog-card').forEach(c => c.classList.remove('active'));
    const target = activeCard || document.getElementById('gmp-blog-grid');
    if (target) scrollToEl(target);
  }

  function initArticleCards() {
    const panel = document.getElementById('gmp-article-panel');
    if (!panel) return;

    const cards = $$('.gmp-blog-card');
    cards.forEach(card => {
      const articleUrl = card.getAttribute('data-article-url');
      if (!articleUrl) return;

      card.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', async (e) => {
          e.preventDefault();

          cards.forEach(c => c.classList.remove('active'));
          card.classList.add('active');

          panel.hidden = false;
          panel.innerHTML = '<div class="gmp-l1-loading"><span></span> Chargement…</div>';
          scrollToEl(panel);

          try {
            const res = await fetch(articleUrl + '?sections=gmp-article');
            if (!res.ok) throw new Error('fetch ' + res.status);
            const data = await res.json();
            const html = data['gmp-article'];
            if (!html) throw new Error('section absente');

            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const articleEl = tmp.querySelector('.gmp-article-page');

            const backBtn = document.createElement('button');
            backBtn.type = 'button';
            backBtn.className = 'gmp-back-btn gmp-back-btn--top';
            backBtn.innerHTML = '&#8679; Retour aux articles';
            backBtn.addEventListener('click', () => {
              history.back();
            });

            panel.innerHTML = '';
            panel.appendChild(backBtn);
            if (articleEl) panel.appendChild(document.adoptNode(articleEl));

            history.pushState({ gmpArticle: true }, '', articleUrl);
            scrollToEl(panel);
          } catch (err) {
            console.error('[GMP] article load error', err);
            panel.innerHTML = '<p class="gmp-l1-error">Erreur de chargement.</p>';
          }
        });
      });
    });
  }

  /* ── Boutons retour/fermer rendus en Liquid (page produit standalone) ──
     Retour navigateur si possible, sinon suit le href (collection du produit) */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-gmp-back]');
    if (!btn) return;
    e.preventDefault();
    if (history.length > 1 && document.referrer.indexOf(window.location.host) !== -1) {
      history.back();
    } else {
      window.location.href = btn.getAttribute('href') || '/';
    }
  });

  /* ═══════════════════════════════════════════════════════
     TRI + FILTRES — pages standalone (hors panels AJAX)
     ═══════════════════════════════════════════════════════ */

  /* Tri : conserve les filtres actifs de l'URL */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('#gmp-sort');
    if (!sel || sel.closest('#gmp-products-panel')) return;
    const params  = new URLSearchParams(window.location.search);
    const newSort = new URLSearchParams(sel.value.replace(/^\?/, '')).get('sort_by') || '';
    if (newSort) params.set('sort_by', newSort);
    params.delete('page');
    window.location = window.location.pathname + '?' + params.toString();
  });

  /* Filtres : GET natif — on retire juste les champs vides pour une URL propre */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('#gmp-filters-form');
    if (!form || form.closest('#gmp-products-panel')) return;
    [...form.elements].forEach(el => {
      if (el.name && el.name.indexOf('filter.') === 0 && el.value === '') el.disabled = true;
    });
  });

  // Initialisation pour les pages L2/L3 (éléments déjà dans le DOM)
  initZoneToggles(null);
  initCatCards(null);
  initInfiniteScroll(null);
  initProductCards(null);
  initArticleCards();


  /* ── Chargement du contenu L2 dans un panel (réutilisé par le clic et l'auto-restore) ── */
  async function loadL2Content(handle, panel) {
    panel.hidden = false;
    panel.innerHTML = '<div class="gmp-l1-loading"><span></span> Chargement…</div>';
    scrollToEl(panel);

    const res = await fetch('/collections/' + handle + '?sections=gmp-collection');
    if (!res.ok) throw new Error('fetch ' + res.status);
    const data = await res.json();
    const html = data['gmp-collection'];
    if (!html) throw new Error('section absente');

    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const l2container = tmp.querySelector('.gmp-collection-page--l2 .gmp-container');
    if (!l2container) throw new Error('L2 container introuvable');

    const backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'gmp-back-btn gmp-back-btn--top';
    backBtn.innerHTML = '&#8679; Retour aux modèles';
    backBtn.addEventListener('click', () => history.back());

    panel.innerHTML = '';
    panel.appendChild(backBtn);
    while (l2container.firstChild) {
      panel.appendChild(document.adoptNode(l2container.firstChild));
    }

    initZoneToggles(panel);
    initCatCards(panel);
    initEclBanners(panel);
    scrollToEl(panel);
  }

  /* ── L1 : clic carte modèle → charge le niveau L2 dans #gmp-l1-panel ── */
  const l1Panel = document.getElementById('gmp-l1-panel');
  const l1Grid  = document.querySelector('.gmp-collection-grid--models');

  if (l1Panel && l1Grid) {
    $$('.gmp-l1-card', l1Grid).forEach(card => {
      card.addEventListener('click', async () => {
        const handle = card.getAttribute('data-l1-handle');
        if (!handle) return;

        $$('.gmp-l1-card').forEach(c => c.classList.remove('active'));
        card.classList.add('active');

        try {
          await loadL2Content(handle, l1Panel);
          pushGmpState({ l2: handle, zone: null, l3: null, p: null });
        } catch (err) {
          console.error('[GMP] L1 panel load error', err);
          l1Panel.innerHTML = '<p class="gmp-l1-error">Erreur de chargement.</p>';
        }
      });
    });
  }


  /* ═══════════════════════════════════════════════════════
     ANNOUNCEMENT BAR — Rotation automatique (8 s)
     ═══════════════════════════════════════════════════════ */

  /* Nommée et rejouable : dans l'éditeur de thème, Shopify re-rend la section à
     chaque réglage modifié — une IIFE lancée au chargement ne verrait jamais les
     annonces reconstruites, et les points disparaîtraient. */
  let _annCtl = null;

  function initAnnouncement() {
    if (_annCtl) { _annCtl.stop(); _annCtl = null; }

    const bar = document.getElementById('gmp-announce');
    if (!bar) return;
    const items = bar.querySelectorAll('.gmp-announce__item');
    if (!items.length) return;

    const dotsEl = document.getElementById('gmp-announce-dots');
    if (dotsEl) dotsEl.innerHTML = '';
    let current = 0;
    let timer = null;

    items.forEach((it, i) => it.classList.toggle('active', i === 0));

    function goTo(idx) {
      items[current].classList.remove('active');
      if (dotsEl && dotsEl.children[current]) dotsEl.children[current].classList.remove('active');
      current = idx;
      items[current].classList.add('active');
      if (dotsEl && dotsEl.children[current]) dotsEl.children[current].classList.add('active');
    }

    function start() {
      if (items.length > 1 && !timer) timer = setInterval(() => goTo((current + 1) % items.length), 8000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (items.length > 1 && dotsEl) {
      items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'gmp-announce__dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Annonce ' + (i + 1));
        dot.addEventListener('click', () => { stop(); goTo(i); start(); });
        dotsEl.appendChild(dot);
      });
    }

    _annCtl = { items, goTo, start, stop };
    start();
  }
  initAnnouncement();

  /* Éditeur de thème : suivre la section re-rendue et le bloc sélectionné.
     Sans ça, sélectionner l'annonce 3 dans l'éditeur laisse la 1 à l'écran et
     le marchand règle une typographie qu'il ne voit pas. */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector && e.target.querySelector('#gmp-announce')) initAnnouncement();
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (!_annCtl) return;
    const item = e.target.closest && e.target.closest('.gmp-announce__item');
    if (!item) return;
    const idx = Array.prototype.indexOf.call(_annCtl.items, item);
    if (idx === -1) return;
    _annCtl.stop();
    _annCtl.goTo(idx);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    if (_annCtl && e.target.closest && e.target.closest('.gmp-announce__item')) _annCtl.start();
  });

  /* ═══════════════════════════════════════════════════════
     INIT — Rafraîchir le compteur panier au chargement
     ═══════════════════════════════════════════════════════ */

  (async function initCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
      syncPanier(cart);
    } catch (e) { /* silencieux */ }
  })();

  /* ═══════════════════════════════════════════════════════
     DIAPORAMA (gmp-slideshow)
     ═══════════════════════════════════════════════════════ */

  $$('.gmp-slideshow').forEach(slideshow => {
    const slides = $$('.gmp-slideshow__slide', slideshow);
    const dots   = $$('.gmp-slideshow__dot',   slideshow);
    if (slides.length < 2) return;

    let current = 0;
    let timer   = null;
    const speed = parseInt(slideshow.dataset.speed || '5', 10) * 1000;
    const auto  = slideshow.dataset.autoplay === 'true';

    function goTo(n) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function startAuto() {
      if (!auto) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), speed);
    }

    const prev = $('.gmp-slideshow__arrow--prev', slideshow);
    const next = $('.gmp-slideshow__arrow--next', slideshow);
    if (prev) prev.addEventListener('click', () => { goTo(current - 1); startAuto(); });
    if (next) next.addEventListener('click', () => { goTo(current + 1); startAuto(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); startAuto(); }));

    startAuto();

    // Pause on hover
    slideshow.addEventListener('mouseenter', () => clearInterval(timer));
    slideshow.addEventListener('mouseleave', startAuto);
  });

  /* ═══════════════════════════════════════════════════════
     COMPARAISON D'IMAGES (gmp-compare)
     ═══════════════════════════════════════════════════════ */

  $$('.gmp-compare').forEach(comp => {
    const range  = comp.querySelector('.gmp-compare__range');
    const before = comp.querySelector('.gmp-compare__before');
    const handle = comp.querySelector('.gmp-compare__handle');
    if (!range || !before) return;

    function update(val) {
      before.style.width = val + '%';
      if (handle) handle.style.left = val + '%';
    }

    range.addEventListener('input', () => update(range.value));
    update(50);
  });

  /* ═══════════════════════════════════════════════════════
     VEILLES OCCASION — « me prévenir quand cette pièce rentre »
     API : POST {GMP_ECLATES_API}/veille, voir server/veilles.py
     ═══════════════════════════════════════════════════════ */

  const VEILLE_API = (window.GMP_ECLATES_API || '').replace(/\/+$/, '');

  /* Le formulaire est injecté dans deux contextes de couleurs opposées : la
     carte SOMBRE d'un éclaté et la fiche produit, qui est BLANCHE. D'où un
     panneau clair et autonome, qui porte ses propres couleurs au lieu d'hériter
     de son conteneur.
     ⚠️ Un bloc pensé pour le fond sombre du cadre devient illisible sur la
     fiche produit — le piège a déjà été payé sur la commande partagée. */
  function veilleFormHtml(o) {
    o = o || {};
    const cli = window.GMP_CLIENT || null;
    const v = (x) => escapeHTML(x == null ? '' : x);
    const libelle = o.libelle || 'Me prévenir quand elle sera disponible';
    const classeBouton = o.discret
      ? 'gmp-veille__ouvrir gmp-veille__ouvrir--discret'
      : 'gmp-veille__ouvrir gmp-btn gmp-btn--outline';

    return '' +
      '<div class="gmp-veille" data-ref="' + v(o.ref) + '"' +
           ' data-designation="' + v(o.designation) + '"' +
           ' data-modele="' + v(o.modele) + '"' +
           ' data-source="' + v(o.source || 'eclates') + '">' +
        '<button type="button" class="' + classeBouton + '">' +
          v(libelle) + '</button>' +

        '<form class="gmp-veille__form" hidden>' +
          '<p class="gmp-veille__intro">Nous vous écrirons dès que cette pièce ' +
            'sera disponible chez nous. Rien d\'autre : pas de publicité, pas de ' +
            'transmission à qui que ce soit.</p>' +

          '<label class="gmp-veille__champ"><span>Nom et prénom</span>' +
            '<input type="text" name="nom" required autocomplete="name" maxlength="80"' +
            ' value="' + v(cli && cli.nom) + '"></label>' +

          '<label class="gmp-veille__champ"><span>Adresse e-mail</span>' +
            '<input type="email" name="email" required autocomplete="email" maxlength="160"' +
            ' value="' + v(cli && cli.email) + '"></label>' +

          '<label class="gmp-veille__champ"><span>Téléphone ' +
            '<i class="gmp-veille__opt">facultatif</i></span>' +
            '<input type="tel" name="telephone" autocomplete="tel" maxlength="30"' +
            ' value="' + v(cli && cli.tel) + '"></label>' +

          /* ⚠️ Le choix du client décide QUI LE MARCHAND PRÉVIENT : GMAPP ne
             propose à la mise en ligne d'une occasion que les veilles
             « occasion » ou « les deux », et pareil pour le neuf (02/10/2026).
             Aucune valeur cochée d'avance, et c'est voulu : une case pré-cochée
             serait validée sans être lue, et le marchand croirait savoir. */
          '<fieldset class="gmp-veille__souhait">' +
            '<legend>Vous la voulez</legend>' +
            '<label><input type="radio" name="souhait" value="occasion" required>' +
              '<span>D\'occasion</span></label>' +
            '<label><input type="radio" name="souhait" value="neuf">' +
              '<span>Neuve</span></label>' +
            '<label><input type="radio" name="souhait" value="les_deux">' +
              '<span>Peu importe</span></label>' +
          '</fieldset>' +

          '<label class="gmp-veille__consent">' +
            '<input type="checkbox" name="consentement" required>' +
            '<span>J\'accepte que ces coordonnées soient conservées 12 mois pour ' +
              'me prévenir de la disponibilité de cette pièce. Chaque message ' +
              'contient un lien pour me désinscrire en un clic.</span></label>' +

          '<p class="gmp-veille__err" hidden role="alert"></p>' +
          '<div class="gmp-veille__actions">' +
            '<button type="submit" class="gmp-btn gmp-btn--red gmp-veille__envoi">' +
              'Me prévenir</button>' +
            '<button type="button" class="gmp-veille__annuler">Annuler</button>' +
          '</div>' +
        '</form>' +

        '<div class="gmp-veille__ok" hidden></div>' +
      '</div>';
  }

  /* Un seul jeu d'écouteurs, posés sur `document`.
     ⚠️ En délégation obligatoirement : ces formulaires sont injectés (carte
     d'éclaté, panneau produit inline) et n'existent pas au chargement de la
     page. Un `querySelectorAll` au démarrage ne trouverait rien. */
  (function initVeilles() {
    document.addEventListener('click', (e) => {
      const ouvrir = e.target.closest('.gmp-veille__ouvrir');
      if (ouvrir) {
        const bloc = ouvrir.closest('.gmp-veille');
        if (!bloc) return;
        ouvrir.hidden = true;
        const f = bloc.querySelector('.gmp-veille__form');
        if (f) {
          f.hidden = false;
          const premier = f.querySelector('input:not([value]), input[value=""]')
                       || f.querySelector('input[name="nom"]');
          if (premier) premier.focus();
        }
        return;
      }
      const annuler = e.target.closest('.gmp-veille__annuler');
      if (annuler) {
        const bloc = annuler.closest('.gmp-veille');
        if (!bloc) return;
        const f = bloc.querySelector('.gmp-veille__form');
        const b = bloc.querySelector('.gmp-veille__ouvrir');
        if (f) f.hidden = true;
        if (b) b.hidden = false;
      }
    });

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.gmp-veille__form');
      if (!form) return;
      e.preventDefault();

      const bloc = form.closest('.gmp-veille');
      const err = form.querySelector('.gmp-veille__err');
      const envoi = form.querySelector('.gmp-veille__envoi');
      const dire = (m) => { if (err) { err.textContent = m; err.hidden = !m; } };
      dire('');

      const val = (n) => (form.querySelector('[name="' + n + '"]') || {}).value || '';
      const souhait = form.querySelector('[name="souhait"]:checked');
      if (!souhait) { dire('Précisez si vous la voulez d\'occasion, neuve, ou peu importe.'); return; }
      const coche = form.querySelector('[name="consentement"]');
      if (!coche || !coche.checked) { dire('Merci de cocher la case avant d\'envoyer.'); return; }

      const corps = {
        etat_souhaite: souhait.value,
        ref: bloc.dataset.ref,
        nom: val('nom').trim(),
        email: val('email').trim(),
        telephone: val('telephone').trim() || null,
        consentement: true,
        source: bloc.dataset.source || 'eclates',
        designation: bloc.dataset.designation || null,
        modele: bloc.dataset.modele || null
      };

      envoi.disabled = true;
      const libelleInitial = envoi.textContent;
      envoi.textContent = 'Envoi…';
      try {
        /* ⚠️ Délai explicite : sans lui, un appel qui ne revient jamais
           laisserait le bouton bloqué sur « Envoi… » indéfiniment. Même règle
           que le parcours de commande partagée. */
        const r = await fetch(VEILLE_API + '/veille', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-GMP-Key': window.GMP_ECLATES_KEY || ''
          },
          body: JSON.stringify(corps),
          signal: AbortSignal.timeout(20000)
        });
        if (!r.ok) {
          let detail = '';
          try { detail = (await r.json()).detail || ''; } catch (_) {}
          dire(messageErreur(r.status, detail));
          return;
        }
        const rep = await r.json();
        const ok = bloc.querySelector('.gmp-veille__ok');
        form.hidden = true;
        if (ok) {
          ok.innerHTML =
            '<p class="gmp-veille__ok-titre">C\'est noté.</p>' +
            '<p>Nous écrirons à <b>' + escapeHTML(corps.email) + '</b> dès que cette ' +
            'pièce sera disponible' +
            ({ occasion: ' d\'occasion', neuf: ' neuve' }[corps.etat_souhaite] || '') +
            (rep.nouvelle === false ? ' — vous étiez déjà inscrit.' : '.') + '</p>';
          ok.hidden = false;
        }
        _gmpTrack('gmp_veille_inscription', { ref: corps.ref, source: corps.source });
      } catch (_) {
        dire('Connexion impossible. Réessayez dans un instant, ou écrivez-nous à ' +
             'contact@gersmotopieces.com.');
      } finally {
        envoi.disabled = false;
        envoi.textContent = libelleInitial;
      }
    });
  })();

  /* Remplit les conteneurs posés en Liquid (fiche produit en rupture).
     ⚠️ À rappeler après chaque injection, comme initProductVariants et les
     autres : une fiche chargée en panneau inline n'existe pas au chargement de
     la page. Le drapeau `gmpVeillePrete` évite qu'un second appel n'écrase un
     formulaire déjà rempli par le client. */
  function initVeilleConteneurs(scope) {
    (scope || document).querySelectorAll('[data-gmp-veille]').forEach((el) => {
      if (el.dataset.gmpVeillePrete) return;
      el.dataset.gmpVeillePrete = '1';
      el.innerHTML = veilleFormHtml({
        ref: el.dataset.ref,
        designation: el.dataset.designation,
        modele: el.dataset.modele || '',
        source: 'produit',
        libelle: 'Me prévenir quand elle revient en stock'
      });
    });
  }
  initVeilleConteneurs(null);

  /* Les messages du serveur sont techniques ; ceux-ci sont pour le client.
     Le détail renvoyé par le proxy n'est repris que pour les erreurs de
     saisie (422), les seules où il dit quelque chose d'utile à lire. */
  function messageErreur(statut, detail) {
    if (statut === 422) return detail || 'Merci de vérifier les informations saisies.';
    if (statut === 429) return 'Trop de demandes pour le moment. Réessayez dans quelques minutes.';
    if (statut === 503) return 'Ce service est momentanément indisponible. Réessayez plus tard.';
    return 'L\'inscription n\'a pas pu être enregistrée. Écrivez-nous à contact@gersmotopieces.com.';
  }

  /* ═══════════════════════════════════════════════════════
     ÉCLATÉS DUCATI — bandeau L2 + hub /pages/eclates
     API : proxy public (window.GMP_ECLATES_API), voir server/
     ═══════════════════════════════════════════════════════ */

  const ECL_API = (window.GMP_ECLATES_API || '').replace(/\/+$/, '');

  /* Options du POST /creer, en un seul endroit — les deux parcours qui créent
     une fiche (pièce neuve absente, commande partagée) doivent envoyer le même
     en-tête, sinon l'un des deux se fait refuser sans que rien ne le signale.
     ⚠️ Le jeton n'est PAS un secret : il vient du thème, donc du HTML public,
     et se lit dans le code source de la page. Il écarte le balayage automatique
     et l'appel au `curl` qui n'a pas lu le site — rien de plus. Ce qui borne
     réellement l'abus, côté serveur, c'est le plafond par adresse IP.
     Le jour où il change, il change ici ET dans le `.env` du VPS. */
  const optionsCreer = () => ({
    method: 'POST',
    headers: { 'X-GMP-Key': window.GMP_ECLATES_KEY || '' },
    signal: sigDelai(45000)
  });

  async function eclGet(path) {
    const res = await fetch(ECL_API + path);
    if (!res.ok) throw new Error('eclates ' + res.status);
    return res.json();
  }

  /* ── Bandeau sur les pages modèle : révélé si le modèle est couvert ── */
  function initEclBanners(scope) {
    if (!ECL_API) return;
    const ctx = scope || document;
    [...ctx.querySelectorAll('.gmp-eclates-banner[data-collection-handle]:not([data-ecl-done])')].forEach(async (banner) => {
      banner.setAttribute('data-ecl-done', '1');
      try {
        const m = await eclGet('/eclates/match?handle=' + encodeURIComponent(banner.dataset.collectionHandle));
        if (!m || !m.family) return;
        const q = new URLSearchParams({ family: m.family });
        if (m.super_model) q.set('sm', m.super_model);
        banner.href = '/pages/eclates?' + q.toString();
        banner.hidden = false;
      } catch (e) { /* API indisponible → bandeau caché */ }
    });
  }
  initEclBanners(null);

  /* ── Hub éclatés ── */
  (function initEclatesHub() {
    const root = document.getElementById('gmp-eclates');
    if (!root || !ECL_API) return;

    const pathEl    = $('#gmp-ecl-path'),   stepEl = $('#gmp-ecl-step');
    const choicesEl = $('#gmp-ecl-choices');
    const groupsEl  = $('#gmp-ecl-groups'), detailEl = $('#gmp-ecl-detail');
    const canvasEl  = $('#gmp-ecl-canvas'), stageEl = $('#gmp-ecl-stage');
    const nomEl     = $('#gmp-ecl-nom'),    titleEl = $('#gmp-ecl-title');
    const occEl     = $('#gmp-ecl-occasion'), neufEl = $('#gmp-ecl-neuf');
    const splitEl   = $('#gmp-ecl-split');
    const loadingEl = $('#gmp-ecl-loading'), errorEl = $('#gmp-ecl-error');

    const lookupCache = {};
    let hotspotEls = [];

    let _busy = 0;
    function busy(on) {
      _busy = Math.max(0, _busy + (on ? 1 : -1));
      loadingEl.hidden = _busy === 0;
      if (on) errorEl.hidden = true;
    }
    function fail(e) { console.error('[GMP] eclates', e); errorEl.hidden = false; }

    /* ── Ordre d'affichage des motos : année, puis cylindrée ───────────────
       Demande du marchand (25/08/2026) : « par année, et par cylindrée
       croissante s'il y en a plusieurs la même année ». C'est l'ordre dans
       lequel un client cherche sa moto — il connaît son année et sa cylindrée,
       pas le rang alphabétique de sa finition. Les tuiles de collections du
       site suivent la même règle, écrite en dur dans `gmp-collection.liquid` ;
       ici les années viennent du proxy (`year_min` sur chaque item de `nav`).

       ⚠️ La borne haute de `cylindree()` est à 1400, pas à 2500 : les noms de
       version contiennent des ANNÉES (« PANIGALE V4 2023 BAUTISTA WORLD
       CHAMPION REPLICA »), et 2023 serait pris pour une cylindrée. Aucune
       Ducati ne dépasse 1285 cm³ — la borne les écarte toutes sans en perdre
       une seule. Un nom sans nombre exploitable (« PANIGALE V4 », « S4R »)
       renvoie 0 : ces modèles se départagent alors par leur nom, ce qui reste
       stable et prévisible. */
    function cylindree(nom) {
      const m = String(nom || '').match(/\d{3,4}/g);
      if (!m) return 0;
      for (const n of m) {
        const v = parseInt(n, 10);
        if (v >= 250 && v <= 1400) return v;
      }
      return 0;
    }

    /* Comparateur commun aux modèles et aux versions. Une entrée sans année part
       à la fin (`Infinity`), jamais au début. */
    function compareParAnneeCylindree(a, b) {
      const ya = a.year_min || Infinity, yb = b.year_min || Infinity;
      if (ya !== yb) return ya - yb;
      const ca = cylindree(a.value), cb = cylindree(b.value);
      if (ca !== cb) return (ca || Infinity) - (cb || Infinity);
      return String(a.value).localeCompare(String(b.value), 'fr',
                                           { sensitivity: 'base', numeric: true });
    }

    /* ── Parcours par étapes : Famille → Modèle → Version → Année ── */
    const LEVELS = [
      { key: 'family',      label: 'Famille', prompt: 'Choisissez votre famille' },
      { key: 'super_model', label: 'Modèle',  prompt: 'Choisissez votre modèle' },
      { key: 'model',       label: 'Version', prompt: 'Choisissez la version exacte',
        hint: "En cas de doute, prenez la version la plus simple (sans mention ABS ni ANNIVERSARY). " +
             "Les versions vendues hors d'Europe sont repliées sous chaque tuile." },
      { key: 'year',        label: 'Année',   prompt: "Choisissez l'année" },
    ];
    const chosen = [null, null, null, null];

    function renderPath() {
      const pills = [];
      chosen.forEach((v, i) => {
        if (v !== null) {
          pills.push('<button type="button" class="gmp-eclates__crumb" data-level="' + i + '" ' +
            'title="Changer de ' + LEVELS[i].label.toLowerCase() + '">' +
            '<small>' + LEVELS[i].label + '</small>' + escapeHTML(v) + ' <span>✕</span></button>');
        }
      });
      pathEl.innerHTML = pills.join('');
      pathEl.hidden = pills.length === 0;
      majEntretiens();
    }

    /* ── Passerelle vers les consommables du modèle choisi ─────────────────
       Le client qui vient chercher une pièce sur un éclaté est exactement celui
       qui roule : la tuile lui met sous les yeux les filtres, plaquettes et
       huiles de SA moto, sans repasser par la navigation collections.

       ⚠️ LE RAPPROCHEMENT VIENT D'UNE TABLE, JAMAIS D'UNE TRANSFORMATION DE
       CHAÎNE. Les deux catalogues ne nomment pas les motos pareil (« 1199
       Panigale » chez Ducati, « Panigale 1199 » à la boutique) et Ducati range
       Diavel 1200, 1260 et V4 sous une seule entrée. Fabriquer le handle au vol
       est le piège déjà payé sur les alias de collections : rien ne signale
       l'erreur, le client part simplement sur les consommables d'une autre
       moto. La table est engendrée hors ligne par
       server/entretiens_map_build.py et vit dans gmp-eclates.liquid.
       ⚠️ Ce qui n'y est pas ne s'invente pas : pas de tuile, et c'est voulu.
       Le catalogue Ducati ne sépare pas les carburateurs des injections, donc
       ni la Monster 900 i.e. ni les SuperSport i.e. n'ont de rapprochement sûr. */
    const entretiensEl = document.getElementById('gmp-ecl-entretiens');
    let ENTRETIENS = null;
    try {
      const brut = document.getElementById('gmp-ecl-entretiens-data');
      if (brut) ENTRETIENS = JSON.parse(brut.textContent);
    } catch (e) { /* table absente ou illisible → pas de tuile, rien de cassé */ }

    function cibleEntretiens() {
      if (!ENTRETIENS || !chosen[0] || !chosen[1] || !chosen[2]) return null;
      const groupe = ENTRETIENS.versions[chosen[0] + '|' + chosen[1]];
      if (!groupe) return null;
      /* Les marchés sont repliés dans la table comme ils le sont à l'écran :
         « Diavel Carbon FL USA » et « Diavel Carbon FL » sont la même moto. */
      const entree = groupe[splitMarche(chosen[2]).base];
      if (entree === undefined) return null;
      let slug;
      if (typeof entree === 'number') {
        slug = ENTRETIENS.slugs[entree];
      } else {
        /* Une version Ducati qui couvre plusieurs millésimes boutique (PANIGALE
           V4 va de 2018 à 2026, la boutique la coupe en 2018 / 2022 / 2025) :
           c'est l'année choisie qui tranche. ⚠️ Sans année connue on n'affiche
           RIEN — prendre le premier reviendrait à tirer au sort entre trois
           motos qui n'ont ni les mêmes filtres ni les mêmes plaquettes. */
        const an = parseInt(chosen[3], 10);
        if (!an) return null;
        const t = entree.find(x => an >= x[1] && an <= x[2]);
        if (!t) return null;
        slug = ENTRETIENS.slugs[t[0]];
      }
      /* `modeles` est reconstruit à chaque rendu par le Liquid : une collection
         supprimée depuis la dernière génération de la table n'y est plus, et la
         tuile disparaît au lieu de mener sur une 404.
         ⚠️ L'entrée vaut [titre, image] depuis le 31/08/2026 — la chaîne nue
         est encore acceptée : le Liquid et ce fichier se déploient séparément,
         et sans ce repli la tuile disparaîtrait entre les deux uploads. */
      const e = slug && ENTRETIENS.modeles[slug];
      if (!e) return null;
      const titre = typeof e === 'string' ? e : e[0];
      const image = typeof e === 'string' ? '' : (e[1] || '');
      return titre ? { slug: slug, titre: titre, image: image } : null;
    }

    function majEntretiens() {
      if (!entretiensEl) return;
      const cible = cibleEntretiens();
      if (!cible) { entretiensEl.hidden = true; return; }
      entretiensEl.href = '/collections/consommables-et-entretiens-' + cible.slug;
      entretiensEl.querySelector('.gmp-eclates__entretiens-nom').textContent =
        cible.titre.replace(/^Consommables et Entretiens\s*/i, '');
      /* Fond photo : le réglage de section l'emporte, sinon l'image de la
         collection visée. ⚠️ La classe `--photo` porte le voile sombre, elle ne
         se pose donc QUE s'il y a une image — sans elle, la tuile garde son
         dégradé d'origine et reste lisible. Poser le voile sur un fond absent
         assombrirait la tuile pour rien. */
      const fond = entretiensEl.querySelector('.gmp-eclates__entretiens-fond');
      const src  = entretiensEl.dataset.fondFixe || cible.image;
      if (fond && src) {
        if (fond.getAttribute('src') !== src) fond.setAttribute('src', src);
        fond.hidden = false;
        entretiensEl.classList.add('gmp-eclates__entretiens--photo');
      } else if (fond) {
        fond.hidden = true;
        entretiensEl.classList.remove('gmp-eclates__entretiens--photo');
      }
      entretiensEl.hidden = false;
    }

    if (entretiensEl) {
      entretiensEl.addEventListener('click', () => {
        try {
          if (typeof gtag === 'function') {
            gtag('event', 'gmp_eclates_entretiens', {
              event_category: 'navigation',
              model: chosen[1] || '', version: chosen[2] || ''
            });
          }
        } catch (e) {}
      });
    }

    function clearFrom(level) {
      for (let i = level; i < 4; i++) chosen[i] = null;
      groupsEl.hidden = true; groupsEl.innerHTML = '';
      detailEl.hidden = true;
      renderPath();
    }

    async function showLevel(level) {
      clearFrom(level);
      const q = new URLSearchParams();
      for (let i = 0; i < level; i++) q.set(LEVELS[i].key, chosen[i]);
      stepEl.innerHTML = escapeHTML(LEVELS[level].prompt) +
        (LEVELS[level].hint ? '<small class="gmp-eclates__step-hint">' + escapeHTML(LEVELS[level].hint) + '</small>' : '');
      stepEl.hidden = false;
      choicesEl.innerHTML = '';
      choicesEl.classList.remove('gmp-eclates__choices--grid');
      busy(true);
      try {
        const data = await eclGet('/eclates/nav' + (q.toString() ? '?' + q.toString() : ''));
        const items = data.items || [];
        if (!items.length) {
          choicesEl.innerHTML = '<p class="gmp-eclates__empty">Aucun éclaté disponible ici pour le moment.</p>';
          return;
        }
        // Un seul choix → on le prend automatiquement
        if (items.length === 1) { pick(level, items[0].value); return; }
        if (LEVELS[level].key === 'model') { renderVersions(items); return; }
        /* ⚠️ NIVEAU « MODÈLE » : L'API REND L'ORDRE ALPHABÉTIQUE, et il est
           absurde pour un client — « 1000, 1100, 1200, 400, 600, 620, 695… »
           met la Monster 1000 de 2003 avant la 400 de 1995. On retrie du plus
           ancien au plus récent, comme les tuiles de collections du site, avec
           la cylindrée en départage à année égale (`year_min` vient du proxy).
           Un modèle sans année connue part à la FIN, jamais en tête : un trou
           de données ne doit pas propulser un modèle là où l'œil se pose. */
        const liste = (LEVELS[level].key === 'super_model')
          ? items.slice().sort(compareParAnneeCylindree)
          : items;
        choicesEl.innerHTML = liste.map(i =>
          '<button type="button" class="gmp-eclates__choice' + (level === 3 ? ' gmp-eclates__choice--year' : '') +
          '" data-value="' + escapeHTML(i.value) + '">' + escapeHTML(i.value) +
          (i.year_min ? '<small class="gmp-eclates__choice-an">' +
             escapeHTML(i.year_min === i.year_max ? String(i.year_min) : i.year_min + ' – ' + i.year_max) +
             '</small>' : '') +
          '</button>').join('');
      } catch (e) { fail(e); } finally { busy(false); }
    }


    /* ── Niveau « Version » : regroupement par version réelle ──────────────
       Ducati décline chaque version par marché (USA, THAILAND, BRASIL…), ce qui
       multipliait chaque ligne par 3 à 5 : 57 pastilles pour 17 vraies versions
       sur le Diavel, 878 pour 404 sur l'ensemble du catalogue. Un client français
       a une moto vendue en Europe — les marchés lointains sont du bruit qui cache
       le seul choix qui le concerne. On les replie donc sous la tuile.          */
    const ECL_MARCHES = ['USA', 'THAILAND', 'BRASIL', 'BRAZIL', 'TAIWAN', 'AUS', 'AUSTRALIA',
                         'CHINA', 'CHN', 'JAPAN', 'JAP', 'KOREA', 'CANADA', 'MEXICO', 'INDIA',
                         'UK', 'ARGENTINA', 'COLOMBIA', 'CHILE', 'RUSSIA'];
    const ECL_RX_MARCHE = new RegExp('^(.*?)[\\s-]+(' + ECL_MARCHES.join('|') + ')$', 'i');

    /* Les suffixes se cumulent (« ICON DARK THAILAND USA ») : on les retire tant
       qu'il en reste, sinon THAILAND resterait collé au nom de base et la version
       européenne « ICON DARK » ne rejoindrait pas son propre groupe. */
    function splitMarche(nom) {
      let base = String(nom).trim();
      const marches = [];
      for (;;) {
        const m = base.match(ECL_RX_MARCHE);
        if (!m || !m[1].trim()) break;
        marches.unshift(m[2].toUpperCase());
        base = m[1].trim();
      }
      return { base: base, marche: marches.length ? marches.join(' ') : null };
    }

    function grouperVersions(items) {
      const ordre = [], par = new Map();
      items.forEach(i => {
        const d = splitMarche(i.value);
        if (!par.has(d.base)) {
          par.set(d.base, { base: d.base, principal: null, marcheSeul: null, variantes: [], planches: 0 });
          ordre.push(d.base);
        }
        const g = par.get(d.base);
        if (d.marche) {
          g.variantes.push({ value: i.value, marche: d.marche, count: i.count || 0,
                             anMin: i.year_min || 0, anMax: i.year_max || 0 });
        } else {
          /* Le compteur est celui de la version qu'on ouvrira réellement, pas la
             somme de tous les marchés : additionner annonçait 622 éclatés là où
             le clic n'en montre que 158. */
          g.principal = i.value;
          g.planches = i.count || 0;
          /* Années servies par le proxy avec l'item : quand elles sont là, plus
             un seul appel réseau n'est nécessaire pour trier (voir
             `chargerAnnees`, qui devient alors inutile). */
          g.anMin = i.year_min || 0;
          g.anMax = i.year_max || 0;
        }
      });
      /* Tri alphabétique insensible à la casse — l'API renvoie les majuscules
         d'abord, ce qui propulsait « DIAVEL FOR BENTLEY » devant le simple
         « Diavel ».
         ⚠️ CE N'EST PLUS L'ORDRE FINAL, seulement un ordre STABLE de repli :
         `renderVersions` retrie par année dès qu'elles sont connues. Il sert
         encore à deux choses — départager deux versions de la même année, et
         rester présentable si le proxy ne répond pas. */
      ordre.sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base', numeric: true }));
      return ordre.map(b => {
        const g = par.get(b);
        /* Groupe sans version « de base » (53 cas dans le catalogue) : l'Europe
           fait référence si elle existe ; sinon, s'il ne reste qu'un marché, la
           tuile le sélectionne en l'affichant. Au-delà, on ne choisit pas à la
           place du client : la tuile ouvre la liste. */
        if (!g.principal) {
          const eu = g.variantes.find(v => v.marche === 'EU');
          if (eu) {
            g.principal = eu.value;
            g.planches = eu.count;
            g.anMin = eu.anMin; g.anMax = eu.anMax;
            g.variantes = g.variantes.filter(v => v !== eu);
          } else if (g.variantes.length === 1) {
            g.principal = g.variantes[0].value;
            g.marcheSeul = g.variantes[0].marche;
            g.planches = g.variantes[0].count;
            g.anMin = g.variantes[0].anMin; g.anMax = g.variantes[0].anMax;
            g.variantes = [];
          }
        }
        return g;
      });
    }

    /* Jeton de génération : `showLevel` peut être relancé (retour arrière, clic
       sur un fil d'Ariane) pendant que les années d'un affichage précédent sont
       encore en vol. Sans ce jeton, le chargement périmé finissait par peindre
       ses tuiles PAR-DESSUS le nouveau niveau — une liste de versions apparaissant
       sur l'écran des années, sans que rien ne l'explique. */
    let genVersions = 0;

    /* ⚠️ LES ANNÉES SONT CHARGÉES AVANT LE RENDU, ET C'EST UN CHANGEMENT ASSUMÉ.
       Elles arrivaient auparavant après coup, par paquets de 4, précisément pour
       ne pas retarder l'affichage. Mais l'ordre des tuiles dépend désormais
       d'elles : les afficher d'abord obligerait à les faire sauter une seconde
       plus tard, sous le doigt du client, ce qui est pire qu'une attente courte.

       Ce qui rend l'attente acceptable, c'est la mesure : en parallélisant à 8 au
       lieu de 4, les 18 versions du Diavel passent de 1,57 s à 0,73 s (relevé sur
       le proxy en production). On attend donc moins d'une seconde, une seule
       fois, et l'ordre est juste du premier coup.

       ⚠️ Le garde-fou de durée n'est PAS optionnel : sans lui, un proxy
       injoignable laisserait la page sur son voile de chargement indéfiniment.
       Au-delà du délai, on rend ce qu'on a — dans l'ordre alphabétique s'il le
       faut. Une liste imparfaite vaut infiniment mieux qu'un écran vide. */
    const ECL_ANNEES_MAX_MS = 6000;
    const ECL_ANNEES_PAR_VAGUE = 8;

    async function chargerAnnees(groupes) {
      for (let i = 0; i < groupes.length; i += ECL_ANNEES_PAR_VAGUE) {
        await Promise.all(groupes.slice(i, i + ECL_ANNEES_PAR_VAGUE).map(async (g) => {
          if (!g.principal) return;
          try {
            const q = new URLSearchParams({ family: chosen[0], super_model: chosen[1], model: g.principal });
            const d = await eclGet('/eclates/nav?' + q.toString());
            const ans = (d.items || []).map(x => parseInt(x.value, 10))
                          .filter(n => !isNaN(n)).sort((a, b) => a - b);
            if (!ans.length) return;
            g.anMin = ans[0];
            g.anMax = ans[ans.length - 1];
          } catch (e) { /* la version gardera son seul nombre d'éclatés */ }
        }));
      }
    }

    /* Étiquette d'une tuile : « 2019 – 2022 · 291 éclatés ». Une seule écriture,
       utilisée au rendu comme au repli — deux copies finiraient par diverger. */
    function metaVersion(g) {
      const planches = g.planches
        ? g.planches + (g.planches > 1 ? ' éclatés' : ' éclaté') : '';
      if (!g.anMin) return planches;
      const ans = (g.anMin === g.anMax) ? String(g.anMin) : g.anMin + ' – ' + g.anMax;
      return planches ? ans + ' · ' + planches : ans;
    }

    async function renderVersions(items) {
      const gen = ++genVersions;
      const groupes = grouperVersions(items);

      /* La grille est portée par le conteneur lui-même : imbriquée dans un
         `flex`, elle se dimensionnait sur son contenu et `auto-fill` retombait
         sur une seule colonne — d'où une interminable colonne de tuiles. */
      choicesEl.classList.add('gmp-eclates__choices--grid');

      /* ⚠️ PLUS AUCUN APPEL NI AUCUNE ATTENTE quand le proxy a déjà joint les
         années aux items (`year_min`) : le tri est immédiat et les tuiles
         apparaissent du premier coup. La cascade de requêtes ci-dessous ne sert
         plus que de repli — proxy pas encore à jour, ou données incomplètes. */
      if (groupes.some(g => g.principal && !g.anMin)) {
        /* On dit ce qu'on attend. Un conteneur vide pendant une seconde se lit
           comme une page cassée, alors qu'une phrase se lit comme un travail en
           cours — et le client patiente sans recliquer. */
        choicesEl.innerHTML =
          '<p class="gmp-eclates__empty" role="status">Classement des versions par année…</p>';
        await Promise.race([
          chargerAnnees(groupes),
          new Promise(r => setTimeout(r, ECL_ANNEES_MAX_MS))
        ]);
        if (gen !== genVersions) return;    // un autre niveau a été demandé entre-temps
      }

      /* ⚠️ TRI CHRONOLOGIQUE, DU PLUS ANCIEN AU PLUS RÉCENT. C'est l'ordre dans
         lequel un client cherche sa moto : il connaît son année, pas le rang
         alphabétique de sa finition. L'ordre alphabétique intercalait la Diavel
         V4 de 2023 entre deux modèles de 2011.
         Départages successifs : la CYLINDRÉE croissante (demande du marchand du
         25/08/2026 — à année égale, un client compare des cylindrées, pas des
         initiales), puis l'année de fin (une série courte passe avant une série
         longue commencée la même année), puis le nom. Sans eux, l'ordre de
         deux versions d'une même année dépendrait du hasard du tri natif.
         ⚠️ Une version dont l'année est inconnue part à la FIN (`Infinity`) et
         non au début : un échec réseau ne doit pas propulser une version en tête
         de liste, là où le client regarde en premier. */
      groupes.sort((a, b) =>
        (a.anMin || Infinity) - (b.anMin || Infinity) ||
        (cylindree(a.base) || Infinity) - (cylindree(b.base) || Infinity) ||
        (a.anMax || Infinity) - (b.anMax || Infinity) ||
        a.base.localeCompare(b.base, 'fr', { sensitivity: 'base', numeric: true }));

      choicesEl.innerHTML =
        groupes.map((g, idx) =>
          '<div class="gmp-eclates__version" data-idx="' + idx + '">' +
            '<button type="button" class="gmp-eclates__version-main"' +
              (g.principal ? ' data-value="' + escapeHTML(g.principal) + '"' : ' data-toggle="1"') + '>' +
              '<span class="gmp-eclates__version-name">' + escapeHTML(g.base) +
                (g.marcheSeul ? ' <em>' + escapeHTML(g.marcheSeul) + '</em>' : '') + '</span>' +
              '<span class="gmp-eclates__version-meta" data-annees>' +
                escapeHTML(metaVersion(g)) + '</span>' +
            '</button>' +
            (g.variantes.length
              ? '<button type="button" class="gmp-eclates__version-more" data-toggle="1">+ ' +
                  g.variantes.length + (g.variantes.length > 1 ? ' marchés' : ' marché') + '</button>' +
                '<div class="gmp-eclates__version-marches" hidden>' +
                  g.variantes.map(v => '<button type="button" class="gmp-eclates__marche" data-value="' +
                    escapeHTML(v.value) + '">' + escapeHTML(v.marche) + '</button>').join('') +
                '</div>'
              : '') +
          '</div>').join('');
    }


    function pick(level, value) {
      chosen[level] = value;
      renderPath();
      if (level === 3) {
        stepEl.textContent = 'Choisissez votre éclaté';
        choicesEl.innerHTML = '';
        loadList();
      } else {
        showLevel(level + 1);
      }
    }

    choicesEl.addEventListener('click', (e) => {
      const bascule = e.target.closest('[data-toggle]');
      if (bascule) {
        const carte = bascule.closest('.gmp-eclates__version');
        const liste = carte && carte.querySelector('.gmp-eclates__version-marches');
        if (liste) { liste.hidden = !liste.hidden; carte.classList.toggle('is-open', !liste.hidden); }
        return;
      }
      const btn = e.target.closest('.gmp-eclates__choice, .gmp-eclates__version-main, .gmp-eclates__marche');
      if (!btn || !btn.dataset.value) return;
      const level = chosen.findIndex(v => v === null);
      if (level !== -1) pick(level, btn.dataset.value);
    });
    pathEl.addEventListener('click', (e) => {
      const crumb = e.target.closest('.gmp-eclates__crumb');
      if (!crumb) return;
      showLevel(parseInt(crumb.dataset.level, 10));
    });

    /* ── Catégories en onglets + vignettes des éclatés ── */
    let _groups = [];
    const CAT_LABELS = { 'CADRE': 'Cadre', 'ELECTRIQUE': 'Électrique', 'MOTEUR': 'Moteur',
                         'CHASSIS': 'Châssis', 'ACCESSOIRES': 'Accessoires' };
    function catLabel(name) {
      const k = String(name || '').trim().toUpperCase();
      return CAT_LABELS[k] || (k.charAt(0) + k.slice(1).toLowerCase());
    }

    function renderThumbs(idx) {
      const wrap = document.getElementById('gmp-ecl-thumbs');
      const g = _groups[idx];
      if (!wrap || !g) return;
      wrap.innerHTML = (g.drawings || []).map(d =>
        '<button type="button" class="gmp-eclates__thumb" data-drawing-id="' + d.id + '" ' +
          'title="' + escapeHTML(d.description || '') + '">' +
          '<span class="gmp-eclates__thumb-img">' +
            (d.image_file
              ? '<img src="' + ECL_API + '/eclates/thumb/' + encodeURIComponent(d.image_file) + '?w=420" ' +
                'alt="" loading="lazy" decoding="async" width="420" height="296">'
              : '') +
          '</span>' +
          '<span class="gmp-eclates__thumb-label">' +
            '<b>' + escapeHTML(d.code || '') + '</b>' + escapeHTML(d.description || '') +
          '</span>' +
        '</button>').join('');
    }

    async function loadList() {
      groupsEl.hidden = true; groupsEl.innerHTML = ''; detailEl.hidden = true;
      busy(true);
      try {
        const q = new URLSearchParams({
          family: chosen[0], super_model: chosen[1],
          model: chosen[2], year: chosen[3],
        });
        const data = await eclGet('/eclates/list?' + q.toString());
        // Sous-groupes sans intérêt pour la boutique (pneus, outillage atelier, lubrifiants)
        const HIDDEN_GROUPS = ['PNEU', 'PNEUS', 'OUTILS', 'OUTILLAGE', 'LUBRIFIANT', 'LUBRIFIANTS'];
        const groups = (data.groups || []).filter(g =>
          HIDDEN_GROUPS.indexOf(String(g.sub_group || '').trim().toUpperCase()) === -1);
        if (!groups.length) { groupsEl.innerHTML = '<p class="gmp-eclates__empty">Aucun éclaté pour cette sélection.</p>'; groupsEl.hidden = false; return; }
        _groups = groups;
        groupsEl.innerHTML =
          '<div class="gmp-eclates__cats">' +
            groups.map((g, i) =>
              '<button type="button" class="gmp-eclates__cat' + (i === 0 ? ' on' : '') + '" data-group="' + i + '">' +
                escapeHTML(catLabel(g.sub_group)) +
                '<span>' + (g.drawings || []).length + '</span>' +
              '</button>').join('') +
          '</div>' +
          '<div class="gmp-eclates__thumbs" id="gmp-ecl-thumbs"></div>';
        renderThumbs(0);
        groupsEl.hidden = false;
      } catch (e) { fail(e); } finally { busy(false); }
    }

    /* ── Viewer : zoom / pan ── */
    let vScale = 1, vTx = 0, vTy = 0;
    /* Empêche de sortir le dessin du cadre */
    function vClamp() {
      if (vScale <= 1) { vTx = 0; vTy = 0; return; }
      const w = stageEl.clientWidth, h = stageEl.clientHeight;
      vTx = Math.min(0, Math.max(w - w * vScale, vTx));
      vTy = Math.min(0, Math.max(h - h * vScale, vTy));
    }
    function vApply() {
      vClamp();
      canvasEl.style.transform = 'translate(' + vTx + 'px,' + vTy + 'px) scale(' + vScale + ')';
      // Zoomé → le doigt déplace le dessin ; sinon → il fait défiler la page
      stageEl.classList.toggle('is-zoomed', vScale > 1);
    }
    function vReset() { vScale = 1; vTx = 0; vTy = 0; vApply(); }
    function vZoom(delta, cx, cy) {
      const prev = vScale;
      vScale = Math.min(6, Math.max(1, vScale + delta));
      if (vScale === prev) return;
      // zoom centré sur (cx, cy) relatif au stage
      const r = stageEl.getBoundingClientRect();
      const px = (cx !== undefined ? cx : r.width / 2), py = (cy !== undefined ? cy : r.height / 2);
      vTx = px - (px - vTx) * (vScale / prev);
      vTy = py - (py - vTy) * (vScale / prev);
      if (vScale === 1) { vTx = 0; vTy = 0; }
      vApply();
    }
    stageEl.addEventListener('wheel', (e) => {
      e.preventDefault();
      const r = stageEl.getBoundingClientRect();
      vZoom(e.deltaY < 0 ? 0.4 : -0.4, e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });
    root.addEventListener('click', (e) => {
      const zb = e.target.closest('[data-ecl-zoom]');
      if (!zb) return;
      const z = zb.getAttribute('data-ecl-zoom');
      if (z === '0') vReset(); else vZoom(z === '+' ? 0.6 : -0.6);
    });
    let dragOrigin = null, dragMoved = false;
    stageEl.addEventListener('pointerdown', (e) => {
      dragOrigin = { x: e.clientX - vTx, y: e.clientY - vTy };
      dragMoved = false;
      // NE PAS capturer ici : la capture redirige le clic vers le cadre et les
      // repères ne le reçoivent plus. On ne capture qu'une fois le glissement réel.
    });
    stageEl.addEventListener('pointermove', (e) => {
      if (!dragOrigin) return;
      if (vScale <= 1) return;          // rien à déplacer : on laisse la page défiler
      const nx = e.clientX - dragOrigin.x, ny = e.clientY - dragOrigin.y;
      if (!dragMoved && Math.abs(nx - vTx) + Math.abs(ny - vTy) > 4) {
        dragMoved = true;
        try { stageEl.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (dragMoved) { vTx = nx; vTy = ny; vApply(); }
    });
    stageEl.addEventListener('pointerup', (e) => {
      dragOrigin = null;
      try { if (stageEl.hasPointerCapture(e.pointerId)) stageEl.releasePointerCapture(e.pointerId); } catch (err) {}
      setTimeout(() => { dragMoved = false; }, 0);
    });
    // pinch (2 doigts)
    let pinchDist = 0, pinchScale = 1;
    stageEl.addEventListener('touchstart', (e) => {
      if (e.touches.length === 2) {
        pinchDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        pinchScale = vScale;
        dragOrigin = null;
      }
    }, { passive: true });
    stageEl.addEventListener('touchmove', (e) => {
      if (e.touches.length === 2 && pinchDist > 0) {
        e.preventDefault();
        const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        const prev = vScale;
        vScale = Math.min(6, Math.max(1, pinchScale * d / pinchDist));
        if (vScale === 1) { vTx = 0; vTy = 0; }
        vApply();
      }
    }, { passive: false });
    stageEl.addEventListener('touchend', (e) => { if (e.touches.length < 2) pinchDist = 0; });

    /* Ne défile que si la fiche n'est pas déjà visible : on garde la liste sous les yeux
       pour enchaîner les pièces */
    function ensureVisible(el) {
      const r = el.getBoundingClientRect();
      const headerH = stickyHeader ? stickyHeader.offsetHeight : 60;
      if (r.top < headerH + 8 || r.top > window.innerHeight - 120) scrollToEl(el);
    }

    /* Amène la ligne au centre de la liste (conteneur scrollable) + surbrillance */
    function revealRow(row) {
      const cRect = nomEl.getBoundingClientRect();
      const rRect = row.getBoundingClientRect();
      const delta = (rRect.top - cRect.top) - (nomEl.clientHeight / 2 - rRect.height / 2);
      nomEl.scrollTo({ top: Math.max(0, nomEl.scrollTop + delta), behavior: 'smooth' });
      row.classList.remove('flash');
      void row.offsetWidth;           // relance l'animation
      row.classList.add('flash');
      // Sur mobile la liste est sous l'image : on amène aussi la liste à l'écran
      if (window.matchMedia('(max-width: 900px)').matches) scrollToEl(nomEl.parentElement);
    }

    function selectPos(pos, fromHotspot) {
      hotspotEls.forEach(h => h.classList.toggle('on', h.dataset.pos === pos));
      let firstRow = null;
      [...nomEl.querySelectorAll('.gmp-eclates__part')].forEach(row => {
        const on = row.dataset.pos === pos;
        row.classList.toggle('on', on);
        if (on && !firstRow) firstRow = row;
      });
      if (!firstRow) return;
      if (fromHotspot) revealRow(firstRow);
      openPartCard(firstRow);
    }

    /* ── Pastilles de disponibilité sur toute la nomenclature (1 seul appel) ── */
    /* Prix en format FR. Shopify renvoie une chaîne ("4.00"), l'API Ducati un
       nombre — d'où la normalisation avant affichage. */
    function eclPrice(v) {
      const n = Number(String(v).replace(',', '.'));
      return isFinite(n) ? n.toFixed(2).replace('.', ',') : escapeHTML(String(v));
    }

    /* Toutes les options en stock, pas seulement la première : une même
       référence peut exister à la fois en occasion et en neuf, et le client doit
       voir les deux prix pour arbitrer. La commande chez Ducati reste un dernier
       recours — l'afficher à côté d'une pièce en stock ne ferait que brouiller. */
    /* Délai annoncé sur une commande Ducati. Un seul endroit : la pastille de
       la nomenclature et la carte de commande doivent dire la même chose, sinon
       le client lit deux promesses différentes sur le même écran. */
    const DELAI_CMD = '72 h ouvrées';

    function pill(kind, txt) {
      return '<span class="gmp-eclates__pill gmp-eclates__pill--' + kind + '">' + txt + '</span>';
    }

    function pillFor(r) {
      /* Aucune donnée pour cette référence — paquet perdu, proxy injoignable,
         ou référence écartée par `lookup_batch`. On n'affiche RIEN.
         ⚠️ Avant, on retombait sur la pastille par défaut : « Sur demande » en
         ambre, qui se lit comme une promesse de commande. Une absence
         d'information n'est pas un état de stock. */
      if (!r) return '';

      const pills = [];
      /* ⚠️ `available` DE SHOPIFY NE VEUT PAS DIRE « NOUS L'AVONS ».
         Un article en survente autorisée (`illimite`) avec 0 en stock est
         `available` : c'est une COMMANDE chez Ducati, pas du stock. Sans ce
         filtre, le repère 31 de la planche 026 (Cavalier unique inférieur)
         affichait une pastille VERTE « Neuf 90,26 € » — c'est-à-dire
         « disponible tout de suite, chez nous » — alors que nous n'en avons
         aucun et que Ducati est en rupture. Le client se serait fait avoir.
         Une offre écartée ici retombe sur le bloc `dispo` plus bas, qui dit la
         vérité (rupture, remplacée, plus disponible).
         ⚠️ `stock`/`illimite` peuvent manquer si le proxy n'est pas à jour :
         on retrouve alors exactement l'ancien comportement, jamais une erreur. */
      const chezNous = (o) => {
        if (!o || !o.available) return false;
        // Proxy pas à jour : `stock` absent. On retrouve l'ancien comportement
        // plutôt que de faire disparaître toutes les pastilles.
        if (o.stock == null) return true;
        return o.stock > 0;          // 0 chez nous = pas chez nous. Point.
      };
      /* ⚠️ L'ORDRE SUIT CELUI DES CADRES : à gauche l'adaptable puis l'occasion,
         à droite le neuf d'origine. Une pastille qui n'annonce pas les choses
         dans l'ordre où le client va les trouver l'oblige à chercher deux fois.
         L'adaptable vient en tête parce qu'une pièce neuve d'équipementier en
         stock se propose avant une occasion. */
      const adapt = (r.neufs || []).find(o => o && o.adaptable && chezNous(o));
      if (adapt) {
        pills.push(pill('neuf', 'Adaptable ' + eclPrice(adapt.price) + ' €'));
      }
      if (chezNous(r.occasion)) {
        pills.push(pill('occ', 'Occasion ' + eclPrice(r.occasion.price) + ' €'));
      }
      /* ⚠️ « NEUF » NE DÉSIGNE PLUS QUE L'ORIGINE DUCATI. Le titre d'un article
         Bihr porte souvent « NEUF » (« Levier Embrayage Noir Mat NEUF -
         Ducati ») : sans ce filtre il ressortait ici comme une pièce d'usine,
         alors que les CGV affirment que seules les pièces neuves d'origine
         viennent du partenaire officiel. Le marqueur vient du SKU, calculé côté
         proxy — le SKU lui-même ne sort jamais, il porte des codes internes.

         ⚠️ LA COULEUR NE CHANGE PAS ENTRE ADAPTABLE ET NEUF, ET C'EST VOULU. Ici
         une couleur signifie un fait et un seul : « disponible tout de suite,
         chez nous ». Occasion et Neuf partagent déjà le vert pour cette raison ;
         une pièce adaptable en stock est tout aussi disponible. C'est le MOT qui
         porte l'origine, jamais la teinte — un cyan « adaptable » aurait inventé
         un troisième état de stock qui n'existe pas. */
      const neufOrig = (r.neufs || []).find(o => o && !o.adaptable && chezNous(o));
      if (neufOrig) {
        pills.push(pill('neuf', 'Neuf ' + eclPrice(neufOrig.price) + ' €'));
      }
      if (pills.length) return pills.join('');

      /* Notre stock épuisé : ce qu'on peut honnêtement promettre dépend du
         dernier scan du catalogue Ducati (bloc `dispo` renvoyé par le proxy).
         Avant, un simple tarif suffisait à afficher « commandable » — y compris
         sur des pièces qui ne sont plus fabriquées depuis des années. */
      const d = r.dispo || {};

      if (d.connu && !d.commandable) {
        return pill('mort', 'Plus disponible');
      }
      /* Plus fabriquée mais stock résiduel : c'est la dernière occasion de
         l'avoir en neuf, ça se dit avant tout le reste. */
      if (d.dernieres_pieces) {
        return pill('partiel', 'Dernières pièces' +
          (r.ducati && r.ducati.price != null ? ' · ' + eclPrice(r.ducati.price) + ' €' : ''));
      }
      if (d.remplace_par) {
        /* ⚠️ La remplaçante peut être en rupture elle aussi. Annoncer seulement
           « Remplacée par X » laisse croire qu'elle est disponible : c'est le
           cas de 36011271A -> 36011271AA, les deux sans stock usine. La couleur
           suit le fait, comme partout ailleurs — bleu quand elle est
           fournissable, orange de rupture quand elle ne l'est pas. */
        return d.remplacant_stock === 'notavailable'
          ? pill('rupture', 'Remplacée · en rupture')
          : pill('remplace', 'Remplacée par ' + escapeHTML(d.remplace_par));
      }
      if (d.stock_usine === 'notavailable') {
        return pill('rupture', 'Rupture temporaire');
      }

      const prix = (r.ducati && r.ducati.price != null)
        ? 'Ducati ' + eclPrice(r.ducati.price) + ' €' : 'Sur demande';
      if (d.stock_usine === 'partialav') {
        return pill('partiel', prix + ' · stock limité');
      }
      /* Le délai ne s'annonce qu'à deux conditions : le scan a vu la pièce en
         stock à l'usine (`delay_days`, posé par le proxy) ET la référence est
         connue de dispo.db. Sur une référence inconnue, `commandable: true` est
         un défaut permissif — on ne sait rien — pas une certitude : afficher un
         délai ferme en ferait une promesse.
         Le libellé commercial est fixé ICI et non côté serveur (qui envoie
         toujours `delay_days: 10`, un nombre de jours calendaires) : c'est du
         texte de vitrine, il n'a pas à imposer un déploiement du VPS. */
      const delai = (d.connu && r.delay_days) ? ' · ' + DELAI_CMD : '';
      return pill('cmd', prix + delai);
    }

    async function loadAvailability() {
      const rows = [...nomEl.querySelectorAll('.gmp-eclates__part')];
      const refs = [...new Set(rows.map(r => r.dataset.ref).filter(Boolean))];
      const missing = refs.filter(r => !(r in lookupCache));
      /* ⚠️ `lookup_batch` plafonne à 60 références par appel et ignore les
         suivantes EN SILENCE (eclates_public_api.py, `[:60]`). Une planche de
         120 pièces — Monster 1200 2014 / planche 26290, par exemple — perdait
         donc la moitié de sa nomenclature : mesuré sur cette planche, 5 pièces
         neuves en stock chez nous restaient invisibles et 4 pièces PLUS
         DISPONIBLES s'affichaient comme commandables. D'où le découpage en
         paquets de 50, sous le plafond. */
      const paquets = [];
      for (let i = 0; i < missing.length; i += 50) paquets.push(missing.slice(i, i + 50));
      await Promise.all(paquets.map(async refsPaquet => {
        try {
          const data = await eclGet('/lookup_batch?refs=' + encodeURIComponent(refsPaquet.join(',')));
          Object.keys(data || {}).forEach(k => { lookupCache[k] = data[k]; });
        } catch (e) { /* paquet perdu : ces lignes resteront sans pastille */ }
      }));
      rows.forEach(row => {
        const box = row.querySelector('.gmp-eclates__status');
        if (box) box.innerHTML = pillFor(lookupCache[row.dataset.ref]);
      });
    }

    /* ── Les deux cadres : occasion sous l'image, neuf sous la liste ── */
    function closePanes() {
      occEl.hidden = true;  occEl.innerHTML = '';
      neufEl.hidden = true; neufEl.innerHTML = '';
      if (splitEl) { splitEl.hidden = true; splitEl.firstElementChild.textContent = ''; }
    }

    function openSplit(row) {
      if (!splitEl) return;
      const name = (row.querySelector('.gmp-eclates__part-name')?.childNodes[0]?.textContent || '').trim();
      splitEl.firstElementChild.textContent =
        'Repère ' + row.dataset.pos + ' · ' + row.dataset.ref + (name ? ' — ' + name : '');
      splitEl.hidden = false;
    }

    /* Couleur de l'en-tête d'un cadre = couleur de la pastille pour le MÊME
       fait. Le cadre « Neuf » ne montre notre stock que si nous en avons ; le
       reste du temps il porte la commande Ducati, ou le refus de vente sur une
       référence morte. Une couleur figée mentait donc dans deux cas sur trois. */
    function paneKind(r) {
      const d = (r && r.dispo) || {};
      return (d.connu && !d.commandable) ? 'mort' : 'cmd';
    }

    function paneHead(label, kind, sub) {
      return '<div class="gmp-eclates__pane-head">' +
          '<span class="gmp-eclates__pane-label gmp-eclates__pane-label--' + kind + '">' + label + '</span>' +
          (sub ? '<span class="gmp-eclates__pane-ref">' + sub + '</span>' : '') +
          '<button type="button" class="gmp-eclates__pane-close" aria-label="Fermer">\u2715</button>' +
        '</div>';
    }

    /* Plusieurs occasions pour une même référence : deux carènes d'un même
       modèle n'ont ni le même état ni le même prix. On propose une barre de
       choix au-dessus de la fiche plutôt que d'empiler des fiches entières —
       le cadre garde sa forme, seul le contenu change au clic. */
    function offresBar(liste, actif, kind) {
      /* Seules les offres achetables sont des choix : une pièce épuisée n'est
         pas une proposition, l'afficher ne ferait qu'encombrer la comparaison.
         Le recours de commande est écarté lui aussi : ce n'est pas une
         alternative à comparer mais ce qu'on propose quand plus personne n'a la
         pièce — et c'est le bloc de commande partagée, sur la fiche, qui y mène.

         ⚠️ **LE RECOURS DE COMMANDE, C'EST `illimite` ET `stock <= 0` — PAS
         `illimite` TOUT SEUL.** C'est le même piège que la pastille de stock de
         la fiche produit : *la survente autorisée ne veut pas dire « personne ne
         l'a »*, elle dit seulement que la vente reste ouverte au-delà de notre
         propre stock. Presque tout notre neuf est en `continue`, y compris les
         pièces posées en rayon chez un équipementier.

         Mesuré le 08/09/2026 sur le repère 33 de la 61340311A, signalé par le
         marchand : DEUX adaptables achetables — Tecnium 30 € et Brembo 45 €,
         une pièce de chaque chez Bihr — et la barre n'en montrait AUCUNE. Le
         `< 2` renvoyait '' et le cadre gauche affichait la seule fiche la plus
         chère, sans jamais dire qu'il existait une autre marque à 30 €. Le
         client ne pouvait pas choisir : il ne savait pas qu'il y avait un choix.

         ⚠️ `stock` est le total **tous emplacements** (le proxy le lit dans
         `inventoryQuantity` de l'API admin), et c'est exactement ce qu'il faut
         ici : la question n'est pas « l'avons-nous sur l'étagère » mais
         « quelqu'un peut-il la livrer ». Ne pas le confondre avec
         l'`inventory_quantity` du Liquid, qui lui ne voit que Gers Moto Pièces —
         les deux portent le même nom et ne comptent pas la même chose. */
      const dispo = (liste || []).filter(o =>
        o && o.available && o.handle && (!o.illimite || o.stock > 0));
      if (dispo.length < 2) return '';
      return '<div class="gmp-eclates__offres">' +
        dispo.map((o, i) =>
          '<button type="button" class="gmp-eclates__offre' +
            (o.handle === actif ? ' on' : '') + '"' +
          ' data-handle="' + escapeHTML(o.handle) + '" data-kind="' + kind + '">' +
            '<b>' + (o.price != null ? eclPrice(o.price) + ' €' : '—') + '</b>' +
            /* ⚠️ LE LIBELLÉ DIT LA NATURE, pas un numéro, dès qu'un équipementier
               est en lice. Comparer deux prix sans savoir lequel est d'usine
               n'est pas un choix éclairé : sur le levier 63140631A l'adaptable
               est à 25 € et l'origine à 60 €, le client doit voir POURQUOI avant
               de cliquer. Quand toutes les offres sont de même nature, le numéro
               suffit et reste.
               ⚠️ Le contraire d'« Adaptable » dépend du CADRE : à gauche
               (`occ`) ce sont des occasions, à droite (`neuf`) du neuf
               d'origine. Écrire « Origine » partout aurait présenté une pièce
               d'occasion comme une pièce d'usine. */
            '<span>' + (dispo.some(x => x.adaptable)
                          ? (o.adaptable ? 'Adaptable'
                                         : (kind === 'occ' ? 'Occasion' : 'Origine'))
                          : 'Offre ' + (i + 1)) + '</span>' +
          '</button>').join('') +
        '</div>';
    }

    /* Commande partagée : le client veut 10 pièces, nous en avons 2. Plutôt que
       de le bloquer ou de survendre, on prend les 2 de notre stock au prix de
       notre stock, et on commande les 8 autres chez Ducati au prix Ducati.
       Deux lignes de panier, deux prix justes.
       Ne s'affiche que si Ducati peut réellement fournir — et jamais sur une
       fiche en survente autorisée, qui n'a pas de limite de stock à dépasser. */
    function initSplit(pane, offre, r, ref) {
      const form = pane.querySelector('#gmp-product-form, .gmp-product-info__form');
      const champ = form && form.querySelector('[name="quantity"]');
      if (!form || !champ || !offre) return;

      const d = r.dispo || {};
      const prixDucati = r.ducati && r.ducati.price != null ? r.ducati.price : null;
      if (offre.illimite || !Number.isInteger(offre.stock) || !d.commandable || prixDucati == null) return;

      let zone = form.querySelector('.gmp-eclates__partage');
      if (!zone) {
        zone = document.createElement('div');
        zone.className = 'gmp-eclates__partage';
        form.appendChild(zone);
      }
      const maj = () => {
        const n = parseInt(champ.value) || 1;
        if (n <= offre.stock) { zone.hidden = true; zone.innerHTML = ''; return; }
        const reste = n - offre.stock;
        zone.hidden = false;
        zone.innerHTML =
          '<p class="gmp-eclates__partage-txt">Nous en avons <b>' + offre.stock + '</b> à ' +
            eclPrice(offre.price) + ' € l\'unité. ' +
            'Les <b>' + reste + '</b> autres peuvent être commandées chez Ducati à ' +
            eclPrice(prixDucati) + ' € l\'unité.</p>' +
          '<button type="button" class="gmp-btn gmp-btn--red gmp-ecl-split"' +
            ' data-ref="' + escapeHTML(ref) + '"' +
            ' data-variant="' + escapeHTML(String(offre.variant_id || '')) + '"' +
            ' data-stock="' + offre.stock + '" data-reste="' + reste + '">' +
            'Ajouter ' + offre.stock + ' + commander ' + reste +
          '</button>';
      };
      champ.addEventListener('input', maj);
      champ.addEventListener('change', maj);
      maj();
    }

    function rowLabel(row) {
      const name = (row.querySelector('.gmp-eclates__part-name')?.childNodes[0]?.textContent || '').trim();
      return '<b>Repère ' + escapeHTML(row.dataset.pos) + '</b> · ' + escapeHTML(row.dataset.ref) +
             (name ? ' — ' + escapeHTML(name) : '');
    }

    /* Cadre 2 : notre stock neuf si on l'a, sinon ce que Ducati permet vraiment.
       Cette carte portait la promesse « nous pouvons la commander pour vous,
       livraison sous X jours » quel que soit l'état réel de la référence. */
    function neufBodyHtml(r, ref, row) {
      const d = r.dispo || {};
      /* Infos transmises à la veille. Elles ne servent qu'au courriel : sans
         elles il annoncerait « Pièce » sans dire laquelle, et le client ne
         reconnaîtrait pas ce qu'il avait demandé. La désignation vient de la
         ligne de nomenclature, le modèle de la cascade (`chosen`). */
      const nomPiece = row
        ? (row.querySelector('.gmp-eclates__part-name')?.childNodes[0]?.textContent || '').trim()
        : '';
      /* La FAMILLE est incluse : sans elle le courriel annonce « 796 2011 »,
         qui ne dit pas de quelle moto il s'agit. On veut « MONSTER 796 2011 ». */
      const modelePiece = [chosen[0], chosen[2] || chosen[1], chosen[3]]
        .filter(Boolean).join(' ');
      const veille = (o) => veilleFormHtml(Object.assign(
        { ref: ref, designation: nomPiece, modele: modelePiece, source: 'eclates' },
        o || {}));
      const prix = (r.ducati && r.ducati.price != null)
        ? Number(r.ducati.price).toFixed(2).replace('.', ',') + ' €' : null;
      const ouvrir = (cls) => '<div class="gmp-eclates__offer-card gmp-eclates__offer-card--' + cls + '">';
      /* `motif` choisit le message pré-rempli du formulaire de contact.
         ⚠️ SANS LUI, TOUS LES BOUTONS ENVOYAIENT LE MÊME TEXTE — celui d'une
         demande de commande. Sur une pièce que la carte vient de déclarer
         incommandable, le client se retrouvait à demander de la commander, avec
         un délai : le message contredisait la page d'où il venait, et l'intention
         réelle (être prévenu si elle rentre en occasion) n'apparaissait nulle
         part. Le marchand devait la deviner. */
      const lienContact = (libelle, refDemandee, motif) =>
        '<a class="gmp-btn gmp-btn--outline" href="/pages/contact?ref=' +
        encodeURIComponent(refDemandee || ref) +
        (motif ? '&motif=' + motif : '') + '">' + libelle + '</a>';

      /* Bouton de commande directe : le VPS crée la fiche produit à la volée,
         puis on l'injecte ici avec son bouton panier. Sans tarif Ducati la
         création échouerait — on retombe alors sur le formulaire de contact. */
      const boutonCommander = (libelle, refCible) =>
        '<button type="button" class="gmp-btn gmp-btn--red gmp-ecl-creer" data-ref="' +
        escapeHTML(refCible || ref) + '">' + libelle + '</button>';
      const commanderOuContact = (libelle, refCible) =>
        (r.ducati && r.ducati.price != null)
          ? boutonCommander(libelle, refCible)
          : lienContact(libelle, refCible);
      const blocPrix = prix
        ? '<p class="gmp-eclates__offer-price gmp-eclates__offer-price--cmd">' + prix +
          '<small>prix Ducati TTC</small></p>'
        : '<p class="gmp-eclates__offer-price gmp-eclates__offer-price--cmd"><small>Prix sur demande</small></p>';

      // Plus au catalogue : aucune commande possible, et on ne le maquille pas.
      if (d.connu && !d.commandable) {
        return ouvrir('none') +
            '<p class="gmp-eclates__offer-title">Pièce neuve non disponible</p>' +
            '<p class="gmp-eclates__offer-note">Cette référence n\'est plus fabriquée par Ducati : ' +
              'nous ne pouvons pas la commander. Nous pouvons en revanche la chercher en occasion.</p>' +
            /* ⚠️ Un libellé ne doit jamais promettre plus que ce que le système
               tient. « Me prévenir » est juste depuis les veilles (26/08/2026) :
               une vraie inscription, honorée par GMAPP à la mise en ligne.
               ⚠️ NEUTRE, sans « en occasion » (02/10/2026) : c'est le client qui
               choisit occasion / neuve / peu importe dans le formulaire, et un
               libellé qui tranche à sa place contredisait ce choix. */
            veille({ libelle: 'Me prévenir quand elle sera disponible' }) +
            '<p class="gmp-eclates__offer-ou">' +
              lienContact('ou nous écrire', null, 'occasion') + '</p>' +
          '</div>';
      }

      if (d.dernieres_pieces) {
        return ouvrir('cmd') +
            '<p class="gmp-eclates__offer-title">Dernières pièces neuves</p>' +
            blocPrix +
            '<p class="gmp-eclates__offer-note">Cette référence <b>n\'est plus fabriquée</b>, ' +
              'mais il en reste chez Ducati. Une fois le stock épuisé, elle ne sera ' +
              'plus disponible qu\'en occasion.</p>' +
            commanderOuContact('Commander cette pièce') +
            veille({ discret: true, libelle: 'Ou me prévenir quand elle sera disponible chez nous' }) +
          '</div>';
      }

      // Remplacée : on donne le nouveau code en clair plutôt que de le substituer
      // en douce — le client doit pouvoir vérifier lui-même à quoi correspond
      // la référence qu'il commande.
      if (d.remplace_par) {
        /* ⚠️ CETTE BRANCHE PASSE AVANT CELLE DE LA RUPTURE : sans le rappel
           ci-dessous, une remplaçante elle aussi en rupture chez Ducati était
           proposée « que nous pouvons commander pour vous », sans un mot sur sa
           disponibilité. Relevé le 27/08/2026 sur 36011271A -> 36011271AA, les
           deux en `notavailable`. Le proxy calcule `remplacant_stock` depuis le
           début ; personne ne le lisait.
           On ne bloque pas la commande (BLOQUER_RUPTURE = False, choix du
           marchand : Ducati honore avec un délai plus long) — on cesse
           seulement de laisser croire qu'elle part tout de suite. */
        const dispoRempl =
          d.remplacant_stock === 'notavailable'
            ? ' <b>Elle est actuellement en rupture chez Ducati</b> : nous pouvons ' +
              'la commander, mais le délai reste à confirmer.'
          : d.remplacant_stock === 'partialav'
            ? ' <b>Il en reste peu chez Ducati</b> — commande possible sous ' +
              'réserve de disponibilité.'
            : '';
        return ouvrir('cmd') +
            '<p class="gmp-eclates__offer-title">Référence remplacée par Ducati</p>' +
            '<p class="gmp-eclates__offer-note">La référence <b>' + escapeHTML(ref) +
              '</b> est remplacée par <b>' + escapeHTML(d.remplace_par) +
              '</b>, que nous pouvons commander pour vous.' + dispoRempl + '</p>' +
            commanderOuContact('Commander la référence ' + d.remplace_par, d.remplace_par) +
            veille({ discret: true, libelle: "Ou me prévenir quand l'originale sera disponible chez nous" }) +
          '</div>';
      }

      if (d.stock_usine === 'notavailable') {
        return ouvrir('cmd') +
            '<p class="gmp-eclates__offer-title">Pièce neuve d\'origine Ducati</p>' +
            blocPrix +
            '<p class="gmp-eclates__offer-note"><b>Rupture temporaire</b> chez Ducati. ' +
              'La pièce est toujours au catalogue : nous pouvons la commander, ' +
              'mais le délai reste à confirmer.</p>' +
            commanderOuContact('Commander cette pièce') +
            veille({ discret: true, libelle: 'Ou me prévenir quand elle sera disponible chez nous' }) +
          '</div>';
      }

      const note = d.stock_usine === 'partialav'
        ? 'Nous ne l\'avons pas en stock. <b>Il en reste peu chez Ducati</b> — ' +
          'nous pouvons la commander, sous réserve de disponibilité.'
        : 'Nous ne l\'avons pas en stock, mais nous pouvons la commander pour vous' +
          (r.delay_days && d.connu ? ' — expédition sous ' + DELAI_CMD + '.' : '.');

      return ouvrir('cmd') +
          '<p class="gmp-eclates__offer-title">Pièce neuve d\'origine Ducati</p>' +
          blocPrix +
          '<p class="gmp-eclates__offer-note">' + note + '</p>' +
          commanderOuContact('Commander cette pièce') +
          veille({ discret: true, libelle: 'Ou me prévenir quand elle sera disponible chez nous' }) +
        '</div>';
    }

    async function openPartCard(row) {
      const ref = row.dataset.ref;
      if (!ref) return;

      const loader = '<div class="gmp-eclates__product-body"><div class="gmp-l1-loading"><span></span> Chargement…</div></div>';
      openSplit(row);
      occEl.hidden = false;
      occEl.innerHTML  = paneHead('Occasion', 'attente', rowLabel(row)) + loader;
      neufEl.hidden = false;
      neufEl.innerHTML = paneHead('Neuf', 'attente', '') + loader;

      try {
        const r = lookupCache[ref] || (lookupCache[ref] = await eclGet('/lookup/' + encodeURIComponent(ref)));

        /* ── Répartition des deux cadres ────────────────────────────────────
           ⚠️ LES ADAPTABLES PASSENT À GAUCHE, AVEC LES OCCASIONS. Le cadre de
           DROITE est réservé au neuf d'origine Ducati — déstockage ou commande
           usine — et ne doit jamais montrer autre chose : c'est lui que le
           client lit comme « la pièce du constructeur ». À gauche vivent les
           alternatives à l'origine, adaptable EN TÊTE puis occasions, parce
           qu'une pièce neuve d'équipementier en stock se propose avant une
           occasion.

           ⚠️ TOUT SE FAIT ICI, PAS DANS LE PROXY, et c'est délibéré : le serveur
           sert AUSSI le thème publié en production, qui ignore `adaptable`.
           Déplacer les adaptables hors de `neufs` côté serveur les ferait
           disparaître du site en ligne sans que rien ne les rattrape. Le proxy
           garde donc son contrat ; c'est le thème qui range. */
        const adaptables = (r.neufs || []).filter(o => o && o.adaptable);
        const neufsOrigine = (r.neufs || []).filter(o => o && !o.adaptable);

        /* ⚠️ TOUTES LES VIGNETTES SE LISENT DU PLUS CHER AU MOINS CHER
           (demande du marchand : adaptables le 26/08/2026, étendu aux occasions
           et au neuf d'origine le 28/08/2026) — c'est l'INVERSE du tri du proxy,
           qui classe par prix croissant. Raison du marchand : sur une pièce
           d'occasion le prix dit l'état, et le client doit voir les plus belles
           pièces en premier.
           ⚠️ Le tri est fait ICI, pas dans le proxy. `lookup` renvoie aussi
           `occasion` / `neuf` — la MEILLEURE offre, au sens du moins cher — que
           lisent les pastilles de nomenclature et GMAPP. Retourner `_rang` côté
           serveur ferait annoncer 40 € là où la pièce part à 15 € : ce n'est pas
           le même besoin, et le serveur sert aussi le thème publié.
           ⚠️ « Disponible d'abord » est CONSERVÉ, et ce n'est pas cosmétique :
           `gaucheActive` ouvre la première vignette DISPONIBLE, donc une offre
           épuisée placée en tête au seul motif qu'elle est chère décalerait la
           vignette ouverte de l'étiquette active. Un prix illisible part en fin
           de liste, jamais en tête.
           ⚠️ L'ordre des GROUPES ne change pas : adaptables d'abord, occasions
           ensuite. Une pièce neuve d'équipementier en stock se propose avant une
           occasion — trier les deux ensemble par prix mêlerait les natures. */
        const prixOffre = o => {
          const v = parseFloat(o && o.price);
          return isNaN(v) ? -Infinity : v;
        };
        const parPrixDecroissant = (a, b) =>
          (a.available === b.available ? 0 : (a.available ? -1 : 1))
          || prixOffre(b) - prixOffre(a);
        adaptables.sort(parPrixDecroissant);
        neufsOrigine.sort(parPrixDecroissant);
        /* ⚠️ `slice()` avant de trier : `r` est l'objet MÉMORISÉ dans
           `lookupCache`. Trier `r.occasions` sur place réordonnerait le cache
           pour tous les usages ultérieurs de la même référence. */
        const occasions = (r.occasions || []).slice().sort(parPrixDecroissant);
        // « Gauche » = ce qu'on propose à la place de l'origine, dans l'ordre.
        const gauche = adaptables.concat(occasions);
        const gaucheActive = gauche.find(o => o && o.available) || null;
        const neufActif = neufsOrigine.find(o => o && o.available) || null;

        // Cadre 1 — alternatives : adaptable d'abord, puis occasion
        if (gaucheActive) {
          occEl.dataset.ref = ref;
          occEl.innerHTML = paneHead(gaucheActive.adaptable ? 'Adaptable' : 'Occasion',
                                     gaucheActive.adaptable ? 'neuf' : 'occ', rowLabel(row)) +
            offresBar(gauche, gaucheActive.handle, 'occ') + loader;
          await injectProduct(gaucheActive.handle, occEl);
          initSplit(occEl, gaucheActive, r, ref);
        } else {
          /* Infos transmises a la veille : la designation vient de la ligne
             de nomenclature, le modele de la cascade (`chosen`). Sans elles le
             courriel annoncerait « Piece » sans dire laquelle. */
          const nomPiece = (row.querySelector('.gmp-eclates__part-name')
                              ?.childNodes[0]?.textContent || '').trim();
          /* La FAMILLE est incluse : sans elle le courriel annonce « 796 2011 »,
             qui ne dit pas de quelle moto il s'agit. On veut « MONSTER 796 2011 ». */
          const modelePiece = [chosen[0], chosen[2] || chosen[1], chosen[3]]
            .filter(Boolean).join(' ');
          occEl.innerHTML = paneHead('Occasion', 'attente', rowLabel(row)) +
            '<div class="gmp-eclates__offer-card gmp-eclates__offer-card--none">' +
              '<p class="gmp-eclates__offer-note">Nous n\'avons pas cette pièce en occasion pour le moment.</p>' +
              /* ⚠️ C'EST ICI QUE LA VEILLE A LE PLUS DE SENS : le client vient
                 de lire « nous ne l'avons pas en occasion ». Ce lien menait au
                 formulaire de contact — un courriel lu une fois, sans liste
                 d'attente. Il porte maintenant la vraie inscription. */
              veilleFormHtml({ ref: ref, designation: nomPiece, modele: modelePiece,
                               source: 'eclates',
                               libelle: 'Me prévenir quand elle sera disponible' }) +
              '<p class="gmp-eclates__offer-ou">' +
                '<a class="gmp-eclates__offer-link" href="/pages/contact?ref=' +
                encodeURIComponent(ref) + '&motif=occasion">ou nous écrire</a></p>' +
            '</div>';
        }

        /* Cadre 2 — NEUF D'ORIGINE DUCATI UNIQUEMENT : notre déstockage s'il en
           reste, sinon la commande chez Ducati. ⚠️ Une pièce d'équipementier n'a
           plus le droit d'apparaître ici, même quand c'est la seule en stock :
           son titre porte « NEUF » et le cadre la ferait passer pour une pièce
           d'usine. Elle est proposée à gauche, elle n'est pas perdue. */
        if (neufActif) {
          neufEl.dataset.ref = ref;
          neufEl.innerHTML = paneHead('Neuf', 'neuf', '') +
            offresBar(neufsOrigine, neufActif.handle, 'neuf') + loader;
          await injectProduct(neufActif.handle, neufEl);
          initSplit(neufEl, neufActif, r, ref);
        } else {
          /* ⚠️ `dataset.ref` se pose DANS LES DEUX BRANCHES. Il ne l'était que
             plus haut, quand une offre existe : sur une pièce sans offre — celle
             qui porte justement le bouton de création — il gardait la référence
             de la pièce ouverte AVANT elle. Le handler de création s'en sert
             pour purger le bon cache. */
          neufEl.dataset.ref = ref;
          neufEl.innerHTML = paneHead('Neuf', paneKind(r), '') + neufBodyHtml(r, ref, row);
        }

        ensureVisible(splitEl && !splitEl.hidden ? splitEl : occEl);
      } catch (e) {
        occEl.innerHTML = paneHead('Occasion', 'attente', rowLabel(row)) +
          '<p class="gmp-l1-error">Impossible de charger cette pièce.</p>';
        neufEl.hidden = true; neufEl.innerHTML = '';
      }
    }

    /* Commande directe d'une pièce neuve absente du catalogue : le proxy crée
       l'article Shopify à la volée, puis on injecte la vraie fiche produit —
       bouton panier et variantes compris. Écouteur délégué et posé une seule
       fois : la carte est réinjectée à chaque ouverture de pièce. */
    const ECL_LOADER = '<div class="gmp-eclates__product-body">' +
      '<div class="gmp-l1-loading"><span></span> Chargement…</div></div>';

    if (neufEl) neufEl.addEventListener('click', async (e) => {
      const btn = e.target.closest('.gmp-ecl-creer');
      if (!btn || btn.disabled) return;
      const ref = btn.dataset.ref;
      if (!ref) return;

      const libelle = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Préparation de la fiche…';
      gmpBusy('Préparation de la fiche produit…');
      try {
        const res = await fetch(ECL_API + '/creer/' + encodeURIComponent(ref),
          optionsCreer());
        if (!res.ok) throw new Error('creer ' + res.status);
        const p = (await res.json()).produit;
        if (!p || !p.handle) throw new Error('produit absent');
        /* Le lookup en cache dit encore « pas de neuf » : le purger, sinon
           rouvrir la pièce reproposerait le bouton de création.
           ⚠️ DEUX RÉFÉRENCES À PURGER, PAS UNE. Sur une référence remplacée, le
           bouton porte LA REMPLAÇANTE (`data-ref`), et c'est elle qu'on vient de
           créer — mais la pièce ouverte, donc l'entrée de cache que relira la
           nomenclature, est l'ORIGINALE. Ne purger que `ref` laissait la carte
           d'origine reproposer indéfiniment « Commander la référence … » pour un
           article désormais créé. */
        delete lookupCache[ref];
        if (neufEl.dataset.ref) delete lookupCache[neufEl.dataset.ref];
        neufEl.innerHTML = paneHead('Neuf', 'cmd', '') + ECL_LOADER;
        await injectProduct(p.handle, neufEl);
      } catch (err) {
        console.error('[GMP] création', err);
        btn.disabled = false;
        btn.textContent = libelle;
        const carte = btn.parentElement;
        if (carte && !carte.querySelector('.gmp-ecl-creer-err')) {
          const msg = document.createElement('p');
          msg.className = 'gmp-eclates__offer-note gmp-ecl-creer-err';
          msg.innerHTML = 'La fiche n\'a pas pu être préparée. ' +
            '<a class="gmp-eclates__offer-link" href="/pages/contact?ref=' +
            encodeURIComponent(ref) + '">Nous contacter pour cette pièce →</a>';
          carte.appendChild(msg);
        }
      } finally {
        gmpBusyOff();
      }
    });

    /* Changement d'offre : on ne recharge que la fiche produit, la barre de
       choix et l'en-tête du cadre restent en place. Écouteur posé une fois sur
       chaque cadre, le contenu étant réinjecté à chaque ouverture de pièce. */
    [occEl, neufEl].forEach((pane) => {
      if (!pane) return;
      pane.addEventListener('click', async (e) => {
        const btn = e.target.closest('.gmp-eclates__offre');
        if (!btn || btn.classList.contains('on')) return;
        const handle = btn.dataset.handle;
        if (!handle) return;
        [...pane.querySelectorAll('.gmp-eclates__offre')]
          .forEach(b => b.classList.toggle('on', b === btn));
        await injectProduct(handle, pane);
        const r = lookupCache[pane.dataset.ref];
        const offre = ((r && (r.occasions || []).concat(r.neufs || [])) || [])
          .find(o => o.handle === handle);
        /* ⚠️ L'EN-TÊTE DOIT SUIVRE L'OFFRE CHOISIE. Le cadre garde volontairement
           sa forme quand on change d'offre — mais son libellé, lui, décrit ce
           qu'il montre. Sans ceci, basculer de l'adaptable vers l'origine
           laissait le titre « ADAPTABLE » au-dessus d'une pièce d'usine : le
           cadre se contredisait lui-même, ce qui est pire que l'absence
           d'information qu'on vient de corriger. */
        /* ⚠️ L'EN-TÊTE DU CADRE GAUCHE CHANGE DE NATURE au fil des offres : il
           mélange volontairement les adaptables et les occasions, l'adaptable en
           tête. Sans cette mise à jour, basculer de l'adaptable vers l'occasion
           laissait le titre « ADAPTABLE » au-dessus d'une pièce d'occasion — le
           cadre se contredisait, ce qui est pire que l'absence d'information
           qu'on vient de corriger. Le cadre DROIT, lui, ne montre que du neuf
           d'origine : son titre ne bouge pas. */
        if (offre && pane === occEl) {
          const lab = pane.querySelector('.gmp-eclates__pane-label');
          if (lab) {
            lab.textContent = offre.adaptable ? 'Adaptable' : 'Occasion';
            lab.className = 'gmp-eclates__pane-label gmp-eclates__pane-label--' +
                            (offre.adaptable ? 'neuf' : 'occ');
          }
        }
        if (r && offre) initSplit(pane, offre, r, pane.dataset.ref);
      });

      /* Exécution du partage : notre stock d'abord, puis la commande Ducati.
         L'article « à commander » est créé au besoin — l'appel est idempotent,
         il renvoie l'existant si la référence a déjà sa fiche. */
      pane.addEventListener('click', async (e) => {
        const btn = e.target.closest('.gmp-ecl-split');
        if (!btn || btn.disabled) return;
        const { ref, variant, stock, reste } = btn.dataset;
        const libelle = btn.textContent;
        btn.disabled = true;
        gmpBusy('Préparation du panier…');
        try {
          btn.textContent = 'Ajout de notre stock…';
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variant), quantity: parseInt(stock) })
          });

          gmpBusy('Commande de la pièce neuve chez Ducati…');
          btn.textContent = 'Préparation de la commande Ducati…';
          const res = await fetch(ECL_API + '/creer/' + encodeURIComponent(ref),
            optionsCreer());
          if (!res.ok) throw new Error('creer ' + res.status);
          const p = (await res.json()).produit;
          if (!p || !p.variant_id) throw new Error('variante absente');

          gmpBusy('Ajout au panier…');
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(p.variant_id), quantity: parseInt(reste) })
          });

          delete lookupCache[ref];
          await refreshCartDrawer();
          /* Le film part AVANT l'ouverture du tiroir : les deux jouent sur
             `body.overflow`, et `gmpBusyOff()` après coup rendrait le
             défilement à la page derrière un tiroir ouvert. */
          gmpBusyOff();
          openCartDrawer();
          btn.textContent = '✓ Ajouté au panier';
        } catch (err) {
          console.error('[GMP] commande partagée', err);
          btn.disabled = false;
          btn.textContent = libelle;
        } finally {
          gmpBusyOff();
        }
      });
    });

    async function injectProduct(handle, pane) {
      const body = pane.querySelector('.gmp-eclates__product-body');
      if (!body) return;
      body.innerHTML = '<div class="gmp-l1-loading"><span></span> Chargement…</div>';
      try {
        const res = await fetch('/products/' + handle + '?sections=gmp-product');
        if (!res.ok) throw new Error('fetch ' + res.status);
        const html = (await res.json())['gmp-product'];
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        let productData = null;
        const scriptEl = tmp.querySelector('script');
        if (scriptEl) {
          const m = scriptEl.textContent.match(/window\.GMP_PRODUCT\s*=\s*(\{[\s\S]*?\});/);
          if (m) { try { productData = JSON.parse(m[1]); } catch (err) {} }
        }
        const page = tmp.querySelector('.gmp-product-page');
        body.innerHTML = '';
        if (page) body.appendChild(document.adoptNode(page));
        initProductGallery(body);
        if (productData) initProductVariants(body, productData);
        initVeilleConteneurs(body);
      } catch (e) {
        body.innerHTML = '<p class="gmp-l1-error">Fiche produit indisponible. <a href="/products/' + handle + '">Ouvrir la page produit</a></p>';
      }
    }

    /* Fermeture des deux cadres (l'ajout au panier passe par le formulaire
       de la fiche injectée, géré en délégation plus haut) */
    [occEl, neufEl].forEach(pane => pane.addEventListener('click', (e) => {
      if (e.target.closest('.gmp-eclates__pane-close')) closePanes();
    }));

    async function loadDrawing(id) {
      busy(true);
      try {
        const d = await eclGet('/eclates/drawing/' + id);
        titleEl.textContent = (d.code ? d.code + ' — ' : '') + (d.description || 'Éclaté');
        closePanes();
        vReset();
        hotspotEls = [];
        canvasEl.innerHTML = '';
        /* Format de la planche précédente effacé : le cadre repart sur son
           gabarit d'attente le temps du chargement, sinon une planche large
           s'afficherait un instant dans la boîte d'une planche en hauteur. */
        stageEl.style.removeProperty('--ecl-ar');
        stageEl.style.removeProperty('--ecl-ar-n');
        const img = document.createElement('img');
        img.className = 'gmp-eclates__img';
        img.alt = d.description || 'Éclaté';
        img.src = ECL_API + '/eclates/image/' + encodeURIComponent(d.image_file || '');
        canvasEl.appendChild(img);
        img.addEventListener('load', () => {
          const W = img.naturalWidth, H = img.naturalHeight;
          if (!W || !H) return;
          /* ⚠️ Le cadre prend le format RÉEL de la planche. Elles ne font pas
             toutes 2000×1410 : sans ça, toute planche plus haute que ce format
             était rognée par le bas — jusqu'à 40 % du dessin perdu, et le zoom
             n'y pouvait rien puisque le pixel était coupé avant lui. */
          stageEl.style.setProperty('--ecl-ar', W + ' / ' + H);
          stageEl.style.setProperty('--ecl-ar-n', String(W / H));
          (d.hotspots || []).forEach(h => {
            const el = document.createElement('span');
            el.className = 'gmp-eclates__hs';
            el.dataset.pos = String(h.pos || '');
            el.style.left   = (h.x1 / W * 100) + '%';
            el.style.top    = (h.y1 / H * 100) + '%';
            el.style.width  = ((h.x2 - h.x1) / W * 100) + '%';
            el.style.height = ((h.y2 - h.y1) / H * 100) + '%';
            el.addEventListener('click', (e) => {
              if (dragMoved) return;
              e.stopPropagation();
              selectPos(el.dataset.pos, true);
            });
            canvasEl.appendChild(el);
            hotspotEls.push(el);
          });
        });

        /* `notes` reprend le ⓘ du catalogue Ducati : il départage les pièces
           qui partagent un repère — coloris d'un couvercle de selle, langues
           d'un manuel, épaisseur d'une cale. Sans lui, trois lignes identiques
           au même repère sont impossibles à distinguer.

           Ducati répète parfois la note dans la désignation : sur ~14 000 notes
           relevées, 22,5 % en sont un simple fragment et n'apprennent rien. On
           les masque. Les 77,5 % restantes portent l'information décisive —
           « BAGUE ARRET ROULEAUX » existe en SECTION RONDE et SECTION CARREE,
           que le titre seul ne permet pas de distinguer. */
        const _sansAccent = (s) => (s || '').toUpperCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Z0-9]/g, '');
        const noteUtile = (p) => {
          if (!p.notes) return '';
          const n = _sansAccent(p.notes);
          return (n && _sansAccent(p.description).includes(n)) ? '' : p.notes;
        };
        nomEl.innerHTML = (d.parts || []).map(p =>
          '<div class="gmp-eclates__part" data-pos="' + escapeHTML(String(p.pos || '')) + '" data-ref="' + escapeHTML(p.code || '') + '">' +
            '<span class="gmp-eclates__part-pos">' + escapeHTML(String(p.pos || '')) + '</span>' +
            '<span class="gmp-eclates__part-name">' + escapeHTML(p.description || '') +
              ' <small>' + escapeHTML(p.code || '') + (p.quantity ? ' · qté ' + escapeHTML(String(p.quantity)) : '') + '</small>' +
            '</span>' +
            /* ⚠️ La note est repliée sur une seule ligne (`nowrap` en CSS) et
               tronquée si elle est longue — mesuré : médiane 18 caractères mais
               jusqu'à 72, et certaines portent un saut de ligne venu de Ducati,
               que le HTML avalerait en silence. On normalise donc les blancs et
               on pose le texte ENTIER en `title` : la pastille reste compacte,
               et rien n'est perdu. */
            (noteUtile(p)
              ? (function (n) {
                  const plat = String(n).replace(/\s+/g, ' ').trim();
                  return '<span class="gmp-eclates__part-note" title="' + escapeHTML(plat) + '">' +
                         escapeHTML(plat) + '</span>';
                })(noteUtile(p))
              : '') +
            '<div class="gmp-eclates__status"></div>' +
          '</div>').join('');
        [...nomEl.querySelectorAll('.gmp-eclates__part')].forEach(row => {
          row.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            hotspotEls.forEach(h => h.classList.toggle('on', h.dataset.pos === row.dataset.pos));
            [...nomEl.querySelectorAll('.gmp-eclates__part')].forEach(r => r.classList.toggle('on', r === row));
            openPartCard(row);
          });
        });
        loadAvailability();

        detailEl.hidden = false;
        scrollToEl(detailEl);
      } catch (e) { fail(e); } finally { busy(false); }
    }

    groupsEl.addEventListener('click', (e) => {
      const cat = e.target.closest('.gmp-eclates__cat');
      if (cat) {
        [...groupsEl.querySelectorAll('.gmp-eclates__cat')].forEach(c => c.classList.toggle('on', c === cat));
        renderThumbs(parseInt(cat.dataset.group, 10));
        return;
      }
      const btn = e.target.closest('[data-drawing-id]');
      if (!btn) return;
      [...groupsEl.querySelectorAll('.gmp-eclates__thumb.on')].forEach(b => b.classList.remove('on'));
      btn.classList.add('on');
      loadDrawing(btn.dataset.drawingId);
    });

    // Init : pré-filtrage éventuel (?family=&sm= depuis le bandeau des pages modèle)
    (async function boot() {
      const params = new URLSearchParams(window.location.search);
      const fam = params.get('family'), sm = params.get('sm');
      if (fam) {
        chosen[0] = fam;
        if (sm) { chosen[1] = sm; renderPath(); showLevel(2); return; }
        renderPath();
        showLevel(1);
        return;
      }
      showLevel(0);
    })();
  })();

  /* ── Pré-remplissage du formulaire de contact depuis ?ref= ── */
  (function prefillContactRef() {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (!ref) return;
    const body = document.getElementById('gmp-contact-body');
    if (!body || body.value) return;
    /* Le message suit l'INTENTION du bouton cliqué. Une pièce hors catalogue
       n'appelle pas la même demande qu'une pièce commandable, et le marchand doit
       pouvoir traiter le courriel sans avoir à deviner ce que le client voulait.
       ⚠️ Auparavant tous les boutons envoyaient le même texte — celui d'une
       demande de commande. Sur une pièce que la carte venait de déclarer
       incommandable, le client se retrouvait à demander de la commander et à
       réclamer un délai : le message contredisait la page d'où il venait. */
    const motif = new URLSearchParams(window.location.search).get('motif');
    if (motif === 'occasion') {
      body.value = 'Bonjour,\nJe cherche la pièce référence ' + ref +
        ' (vue sur vos éclatés).\nElle n\'est plus fabriquée par Ducati : ' +
        'pourriez-vous me recontacter si vous en trouvez une en occasion ?\nMerci.';
    } else {
      body.value = 'Bonjour,\nJe souhaite commander la pièce référence ' + ref +
        ' (vue sur vos éclatés).\nMerci de me confirmer la disponibilité et le délai.';
    }
  })();

  /* ═══════════════════════════════════════════════════════
     AUTO-RESTORE — Reconstruit la navigation depuis les balises URL
     ?l2=  →  L1 page : recharge le modèle + catégorie + produit
     ?l3=  →  L2 page (standalone) : recharge catégorie + produit
     ?p=   →  L3 page : rouvre le produit inline
     ═══════════════════════════════════════════════════════ */

  /* L1 page : restaure l2 → l3 → produit en cascade */
  (async function autoRestoreL1() {
    const panel = document.getElementById('gmp-l1-panel');
    const grid  = document.querySelector('.gmp-collection-grid--models');
    if (!panel || !grid) return;

    const params   = new URLSearchParams(window.location.search);
    const l2Handle = params.get('l2');
    if (!l2Handle) return;

    const card = grid.querySelector('.gmp-l1-card[data-l1-handle="' + l2Handle + '"]');
    if (card) { $$('.gmp-l1-card').forEach(c => c.classList.remove('active')); card.classList.add('active'); }

    try { await loadL2Content(l2Handle, panel); } catch(e) { console.error('[GMP] restore L2', e); return; }

    const l3Handle = params.get('l3');
    if (!l3Handle) return;

    const productsPanel = panel.querySelector('#gmp-products-panel');
    if (!productsPanel) return;

    // Activer la cat card et ouvrir sa zone accordion
    const catCard = panel.querySelector('.gmp-cat-card[data-col-handle="' + l3Handle + '"]');
    if (catCard) {
      catCard.classList.add('active');
      const zoneGrid = catCard.closest('#gmp-pieces-grid, #gmp-entretiens-grid, #gmp-accessoires-grid');
      if (zoneGrid) {
        zoneGrid.hidden = false;
        const zoneKey = zoneGrid.id.replace('gmp-', '').replace('-grid', '');
        const zoneBtn = panel.querySelector('[data-zone-toggle="' + zoneKey + '"]');
        if (zoneBtn) zoneBtn.setAttribute('aria-expanded', 'true');
      }
    }

    productsPanel.hidden = false;
    try { await loadProducts(l3Handle, null, productsPanel, null); } catch(e) { console.error('[GMP] restore L3', e); return; }

    const pHandle = params.get('p');
    if (!pHandle) { scrollToEl(productsPanel); return; }

    const productPanel = productsPanel.querySelector('#gmp-product-panel');
    if (!productPanel) return;

    try { await loadProductInPanel('/products/' + pHandle, productPanel, true); }
    catch(e) { console.error('[GMP] restore produit depuis L1', e); }
  })();

  /* L2 standalone : restaure l3 → produit en cascade */
  (async function autoRestoreL2() {
    if (document.getElementById('gmp-l1-panel')) return;
    const productsPanel = document.getElementById('gmp-products-panel');
    if (!productsPanel) return;

    const params   = new URLSearchParams(window.location.search);
    const l3Handle = params.get('l3');
    if (!l3Handle) return;

    // Activer la cat card et ouvrir sa zone accordion
    const catCard = document.querySelector('.gmp-cat-card[data-col-handle="' + l3Handle + '"]');
    if (catCard) {
      catCard.classList.add('active');
      const zoneGrid = catCard.closest('#gmp-pieces-grid, #gmp-entretiens-grid, #gmp-accessoires-grid');
      if (zoneGrid) {
        zoneGrid.hidden = false;
        const zoneKey = zoneGrid.id.replace('gmp-', '').replace('-grid', '');
        const zoneBtn = document.querySelector('[data-zone-toggle="' + zoneKey + '"]');
        if (zoneBtn) zoneBtn.setAttribute('aria-expanded', 'true');
      }
    }

    productsPanel.hidden = false;
    try { await loadProducts(l3Handle, null, productsPanel, null); } catch(e) { console.error('[GMP] restore L3', e); return; }

    const pHandle = params.get('p');
    if (!pHandle) { scrollToEl(productsPanel); return; }

    const productPanel = productsPanel.querySelector('#gmp-product-panel');
    if (!productPanel) return;

    try { await loadProductInPanel('/products/' + pHandle, productPanel, true); }
    catch(e) { console.error('[GMP] restore produit depuis L2', e); }
  })();

  /* L3 produits : restaure le produit ouvert (?p=handle) */
  (async function autoRestoreL3() {
    if (document.getElementById('gmp-l1-panel') || document.getElementById('gmp-products-panel')) return;
    const panel  = document.getElementById('gmp-product-panel');
    if (!panel) return;
    const handle = new URLSearchParams(window.location.search).get('p');
    if (!handle) return;

    const card = document.querySelector('.gmp-product-card[data-product-url*="/' + handle + '"]');
    if (card) card.classList.add('active');

    try { await loadProductInPanel('/products/' + handle, panel, true); }
    catch(e) { console.error('[GMP] restore produit L3', e); panel.hidden = true; }
  })();

})();
